"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7437],{

/***/ 8837:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ LOCATION_MODAL_VARIANTS; },
/* harmony export */   "R": function() { return /* binding */ MODAL_VARIANTS; }
/* harmony export */ });
var MODAL_VARIANTS;
(function(MODAL_VARIANTS) {
    MODAL_VARIANTS["FULL_SCREEN"] = "fullScreen";
    MODAL_VARIANTS["SIDE_MODAL"] = "sideModal";
    MODAL_VARIANTS["BOTTOM_MODAL"] = "bottomModal";
    MODAL_VARIANTS["NONE"] = "none";
})(MODAL_VARIANTS || (MODAL_VARIANTS = {}));
var LOCATION_MODAL_VARIANTS;
(function(LOCATION_MODAL_VARIANTS) {
    LOCATION_MODAL_VARIANTS["CONTACT"] = "contact";
    LOCATION_MODAL_VARIANTS["PROFILE_SELECTION"] = "profileSelection";
    LOCATION_MODAL_VARIANTS["NONE"] = "none";
})(LOCATION_MODAL_VARIANTS || (LOCATION_MODAL_VARIANTS = {}));


/***/ }),

/***/ 18262:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ getDefaultExportFromCjs; },
/* harmony export */   "t": function() { return /* binding */ commonjsGlobal; }
/* harmony export */ });
var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof __webpack_require__.g !== 'undefined' ? __webpack_require__.g : typeof self !== 'undefined' ? self : {};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}




/***/ }),

/***/ 59762:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ dayjs_min; }
/* harmony export */ });
var dayjs_min = {exports: {}};




/***/ }),

/***/ 55870:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ classnames; }
/* harmony export */ });
var classnames = {exports: {}};




/***/ }),

/***/ 38614:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ propTypes; }
/* harmony export */ });
var propTypes = {exports: {}};




/***/ }),

/***/ 20120:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "vl": function() { return /* binding */ index_esm_SCREENS; },
  "Iw": function() { return /* binding */ calendarUtils; },
  "ZP": function() { return /* binding */ App; }
});

// UNUSED EXPORTS: BOOKING_THEMES

;// CONCATENATED MODULE: ../../../packages/hermes-booking-calendar/lib/_virtual/_tslib.esm.js
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};



// EXTERNAL MODULE: ../../../node_modules/react/index.js
var react = __webpack_require__(32735);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/styles/styled.esm.js
var styled_esm = __webpack_require__(99611);
;// CONCATENATED MODULE: ../../../packages/hermes-booking-calendar/lib/components/TimeItem/styles.esm.js


const Container = (0,styled_esm/* default */.ZP)('div')(({ theme, selected }) => ({
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '16px',
    backgroundColor: selected
        ? theme.palette.primary.main
        : theme.palette.background.default,
    color: selected ? theme.palette.common.white : theme.palette.text.primary,
    border: `solid thin ${theme.palette.grey[600]}`,
    width: '84px',
    padding: '11px 10px',
    gap: '8px',
    cursor: 'pointer',
    userSelect: 'none',
    '&:hover, &:active': {
        borderColor: theme.palette.primary.main,
    },
    '&[disabled]': {
        backgroundColor: theme.palette.background.light3,
        borderColor: theme.palette.grey[100],
        color: theme.palette.text.secondary,
        pointerEvents: 'none',
        '&>span': {
            fontWeight: 400,
        },
    },
    '@media (max-width: 480px)': {
        padding: '11px 0',
    },
}));
const ValueWrapper = (0,styled_esm/* default */.ZP)('span')({
    fontFamily: `'Poppins', sans-serif`,
    fontSize: '16px',
    fontWeight: 600,
    lineHeight: '24px',
    textAlign: 'center',
});
const FirstAvailable = (0,styled_esm/* default */.ZP)('div')(({ theme }) => ({
    borderRadius: '50%',
    flexShrink: 0,
    backgroundColor: theme.palette.system.green,
    height: '16px',
    width: '16px',
    minHeight: '16px',
    minWidth: '16px',
}));



;// CONCATENATED MODULE: ../../../packages/hermes-booking-calendar/lib/components/LocationDropdown/styles.esm.js


const styles_esm_Container = (0,styled_esm/* default */.ZP)('div')(({ theme }) => ({
    display: 'flex',
    padding: '13px 20px 13px 20px',
    borderRadius: '32px',
    border: '1px solid #D5DEF9',
    justifyContent: 'space-between',
    alignItems: 'center',
    cursor: 'pointer',
    gap: '10px',
    width: '100%',
    boxSizing: 'border-box',
    userSelect: 'none',
    '&>svg': {
        color: theme.palette.system.darkNavy900,
    },
    '&:hover, &:active': {
        border: '1px solid #809BEC',
        '&>svg': {
            color: theme.palette.primary.main,
        },
    },
}));
const ContentWrapper = (0,styled_esm/* default */.ZP)('div')({
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
});
const RatingWrapper = (0,styled_esm/* default */.ZP)('div')({
    fontFamily: `'Poppins', sans-serif`,
    fontSize: '13px',
    fontWeight: 400,
    lineHeight: '20px',
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'nowrap',
    gap: '4px',
    userSelect: 'none',
    '&>span': {
        whiteSpace: 'nowrap',
    },
});
const Label = (0,styled_esm/* default */.ZP)('div')({
    fontFamily: `'Poppins', sans-serif`,
    fontSize: '14px',
    fontWeight: 600,
    lineHeight: '20px',
    textAlign: 'left',
});



;// CONCATENATED MODULE: ../../../packages/hermes-booking-calendar/lib/icons/Star.esm.js


const Star = () => (react.createElement("svg", { width: "13", height: "12", viewBox: "0 0 13 12", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    react.createElement("path", { d: "M6.91286 10.2283C6.63347 10.0838 6.30012 10.0838 6.02074 10.2283L3.18351 11.696C2.83676 11.8753 2.44936 11.582 2.51199 11.2227L3.05385 8.1141C3.10788 7.80414 3.00316 7.48884 2.77592 7.27088L0.480557 5.06937C0.212761 4.81252 0.354075 4.35757 0.73734 4.30278L3.90945 3.84924C4.22112 3.80468 4.49247 3.61177 4.63342 3.33075L6.05203 0.502458C6.22087 0.165847 6.71272 0.165847 6.88156 0.502459L8.30017 3.33075C8.44113 3.61177 8.71247 3.80468 9.02414 3.84924L12.1963 4.30278C12.5795 4.35757 12.7208 4.81252 12.453 5.06937L10.1577 7.27088C9.93043 7.48884 9.82572 7.80414 9.87975 8.1141L10.4216 11.2227C10.4842 11.582 10.0968 11.8753 9.75008 11.696L6.91286 10.2283Z", fill: "#00E5D0", stroke: "#00897D", strokeWidth: "0.5" })));



;// CONCATENATED MODULE: ../../../packages/hermes-booking-calendar/lib/icons/Caret.esm.js


const Caret = () => (react.createElement("svg", { width: "14", height: "9", viewBox: "0 0 14 9", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    react.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.3789 0.708984C12.0643 0.708984 11.7836 0.854293 11.6003 1.08146L7.09206 5.57985L2.50206 0.999848L2.49613 1.00577C2.31487 0.82252 2.06327 0.708985 1.78516 0.708985C1.23287 0.708985 0.785156 1.1567 0.785156 1.70898C0.785156 2.04618 0.952054 2.3444 1.20775 2.52554L7.09206 8.40985L13.074 2.42794C13.262 2.24612 13.3789 1.9912 13.3789 1.70898C13.3789 1.1567 12.9312 0.708984 12.3789 0.708984Z", fill: "currentColor" })));



;// CONCATENATED MODULE: ../../../packages/hermes-booking-calendar/lib/components/LocationDropdown/index.esm.js






const ContainerComponent = ({ children, disabled, onClick, }) => disabled ? (react.createElement("div", { style: { width: '100%' } }, children)) : (react.createElement(styles_esm_Container, { onClick: onClick }, children));
const LocationDropdown = ({ disabled, label, rating, reviewsNumber, onClick, }) => (react.createElement(ContainerComponent, { disabled: disabled, onClick: onClick },
    react.createElement(ContentWrapper, null,
        react.createElement(Label, null, label),
        react.createElement(RatingWrapper, null,
            react.createElement(Star, null),
            react.createElement("span", null,
                rating,
                " (",
                reviewsNumber,
                ")"))),
    disabled ? null : react.createElement(Caret, null)));



// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Box/Box.esm.js + 1 modules
var Box_esm = __webpack_require__(4595);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Typography/Typography.esm.js + 1 modules
var Typography_esm = __webpack_require__(75320);
;// CONCATENATED MODULE: ../../../packages/hermes-booking-calendar/lib/components/DateItem/styles.esm.js


const DateItem_styles_esm_Container = (0,styled_esm/* default */.ZP)(Box_esm/* default */.Z, {
    shouldForwardProp: (prop) => prop !== 'selected',
})(({ theme, selected }) => (Object.assign(Object.assign({ position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '50%', backgroundColor: selected
        ? theme.palette.common.bgColor
        : theme.palette.background.default, width: 50, height: 50, cursor: 'pointer', userSelect: 'none' }, theme.resolveThemeStyles({
    default: {
        border: `solid thin ${theme.palette.grey[600]}`,
        color: selected ? theme.palette.text.light : theme.palette.text.primary,
    },
    wpa: {
        border: `solid thin ${selected ? theme.palette.common.border : theme.palette.grey[600]}`,
        color: selected ? theme.palette.common.color : theme.palette.text.primary,
    },
})), { '&>span>svg': {
        color: theme.palette.common.border,
    }, '&:hover, &:active': {
        borderColor: theme.palette.common.border,
    }, '&[disabled]': Object.assign(Object.assign({ backgroundColor: 'transparent', border: 'none' }, theme.resolveThemeStyles({
        default: {
            color: theme.palette.text.secondary,
        },
        wpa: {
            color: theme.palette.grey[400],
        },
    })), { pointerEvents: 'none', '&>span': {
            fontWeight: 400,
        } }), '@media (max-width: 480px)': {
        width: 35,
        height: 35,
    } })));
const styles_esm_ValueWrapper = (0,styled_esm/* default */.ZP)(Typography_esm/* default */.Z)({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontFamily: `'Poppins', sans-serif`,
    fontSize: '16px',
    fontWeight: 600,
    lineHeight: '24px',
    textAlign: 'center',
});
const styles_esm_FirstAvailable = (0,styled_esm/* default */.ZP)(Box_esm/* default */.Z)(({ theme }) => ({
    position: 'absolute',
    borderRadius: '50%',
    backgroundColor: theme.palette.system.green,
    height: '16px',
    width: '16px',
    bottom: 0,
    right: -2,
}));



;// CONCATENATED MODULE: ../../../packages/hermes-booking-calendar/lib/components/DateItem/index.esm.js



const DateItem = ({ sx, value, firstAvailable, selected, disabled, onClick, }) => {
    return (react.createElement(DateItem_styles_esm_Container, { sx: sx, onClick: onClick, disabled: disabled, selected: selected },
        react.createElement(styles_esm_ValueWrapper, { sx: { color: disabled ? '#9FAABE' : 'inherit' }, component: "span" }, value),
        firstAvailable ? react.createElement(styles_esm_FirstAvailable, null) : null));
};



;// CONCATENATED MODULE: ../../../packages/hermes-booking-calendar/lib/constants.esm.js
const DATE_LOCALE = 'en-GB';
var BUTTON_VARIANT;
(function (BUTTON_VARIANT) {
    BUTTON_VARIANT[BUTTON_VARIANT["PRIMARY1"] = 1] = "PRIMARY1";
    BUTTON_VARIANT[BUTTON_VARIANT["PRIMARY2"] = 2] = "PRIMARY2";
    BUTTON_VARIANT[BUTTON_VARIANT["TERTIARY"] = 3] = "TERTIARY";
    BUTTON_VARIANT[BUTTON_VARIANT["SECONDARY"] = 4] = "SECONDARY";
})(BUTTON_VARIANT || (BUTTON_VARIANT = {}));
var BUTTON_DIRECTION;
(function (BUTTON_DIRECTION) {
    BUTTON_DIRECTION[BUTTON_DIRECTION["RIGHT"] = 1] = "RIGHT";
    BUTTON_DIRECTION[BUTTON_DIRECTION["LEFT"] = 2] = "LEFT";
    BUTTON_DIRECTION[BUTTON_DIRECTION["TOP"] = 3] = "TOP";
    BUTTON_DIRECTION[BUTTON_DIRECTION["BOTTOM"] = 4] = "BOTTOM";
})(BUTTON_DIRECTION || (BUTTON_DIRECTION = {}));
var SCREENS;
(function (SCREENS) {
    SCREENS[SCREENS["CALENDAR_PREVIEW"] = 0] = "CALENDAR_PREVIEW";
    SCREENS[SCREENS["DATE_SELECTION"] = 1] = "DATE_SELECTION";
    SCREENS[SCREENS["SLOT_SELECTION"] = 2] = "SLOT_SELECTION";
    SCREENS[SCREENS["BOOKING_FORM"] = 3] = "BOOKING_FORM";
    SCREENS[SCREENS["SUCCESS_APPOINTMENT"] = 4] = "SUCCESS_APPOINTMENT";
    SCREENS[SCREENS["SLOT_NOT_AVAILABLE"] = 5] = "SLOT_NOT_AVAILABLE";
    SCREENS[SCREENS["CAPTCHA_ERROR"] = 6] = "CAPTCHA_ERROR";
})(SCREENS || (SCREENS = {}));



// EXTERNAL MODULE: ../../../packages/hermes-booking-calendar/lib/node_modules/dayjs/dayjs.min.esm.js
var dayjs_min_esm = __webpack_require__(99921);
;// CONCATENATED MODULE: ../../../packages/hermes-booking-calendar/lib/components/Calendar/utils.esm.js



const getDaysInMonth = (year, month) => new Date(year, month + 1, 0).getDate();
const getStartDayOfMonth = (date) => {
    const startDay = new Date(date.getFullYear(), date.getMonth(), 1).getDay();
    return (startDay + 6) % 7;
};
const getToday = () => new Date();
const formatDate = (date) => date.toISOString().split('T')[0];
const formatDateWithoutTimezone = (date) => (0,dayjs_min_esm/* default */.Z)(date).format('YYYY-MM-DD');
const formatTime = (date) => {
    var _a, _b, _c, _d;
    return (_d = (_c = (_b = (_a = date
        .toLocaleDateString(DATE_LOCALE, {
        hour: 'numeric',
        minute: '2-digit',
        hour12: true,
    })).split) === null || _b === void 0 ? void 0 : _b.call(_a, ', ')) === null || _c === void 0 ? void 0 : _c[1]) === null || _d === void 0 ? void 0 : _d.replace(' ', '');
};
const getWithTimezoneOffset = (date) => {
    const userTimezoneOffset = -date.getTimezoneOffset() * 60 * 1000;
    return new Date(date.getTime() + userTimezoneOffset);
};
const formatDateStringToDisplay = (dateString) => dateString
    ? getWithTimezoneOffset(new Date(dateString)).toLocaleDateString(DATE_LOCALE, {
        weekday: 'short',
        day: 'numeric',
        month: 'short',
    })
    : undefined;
const formatTimeStringToDisplay = (timeString) => timeString ? formatTime(new Date(`1875-05-20 ${timeString}`)) : undefined;
const sortDatesFn = (a, b) => a.getTime() - b.getTime();
const generateDaysForMonth = (year, month) => {
    const daysInThisMonth = getDaysInMonth(year, month);
    const firstDayIndex = getStartDayOfMonth(new Date(year, month));
    const today = getToday();
    const currentMonthDays = [];
    for (let i = 1; i <= daysInThisMonth; i++) {
        const date = new Date(year, month, i);
        currentMonthDays.push({
            date: getWithTimezoneOffset(date),
            isCurrentMonth: true,
            isToday: today.getDate() === i &&
                today.getMonth() === month &&
                today.getFullYear() === year,
        });
    }
    const previousMonthDays = Array.from({ length: firstDayIndex }, (_, i) => ({
        date: new Date(year, month, i - firstDayIndex + 1),
        isCurrentMonth: false,
        isToday: false,
    }));
    return [...previousMonthDays, ...currentMonthDays];
};



;// CONCATENATED MODULE: ../../../packages/hermes-booking-calendar/lib/components/TimeItem/index.esm.js



const TimeItem = ({ sx, value, firstAvailable, selected, disabled, onClick, }) => {
    return (react.createElement(Container, { sx: sx, onClick: onClick, disabled: disabled, selected: selected },
        firstAvailable && !selected ? react.createElement(FirstAvailable, null) : null,
        react.createElement(ValueWrapper, null, value)));
};



// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Button/Button.esm.js + 2 modules
var Button_esm = __webpack_require__(77428);
;// CONCATENATED MODULE: ../../../packages/hermes-booking-calendar/lib/icons/ArrowRight.esm.js


const ArrowRight = () => {
    return (react.createElement("svg", { width: "17", height: "16", viewBox: "0 0 17 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        react.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.654 3.60529L7.65245 3.60684L11.3724 7.33351L3.26025 7.33351C3.25987 7.33351 3.25949 7.33351 3.25911 7.33351C2.89092 7.33351 2.59245 7.63199 2.59245 8.00018C2.59245 8.36837 2.89092 8.66684 3.25911 8.66684L11.3724 8.66684L7.65245 12.3935L7.65369 12.3948C7.52404 12.516 7.44301 12.6885 7.44301 12.88C7.44301 13.2469 7.74041 13.5443 8.10727 13.5443C8.30035 13.5443 8.47419 13.4619 8.59556 13.3304L13.9258 8.00018L8.6153 2.68969C8.49358 2.55181 8.31551 2.46484 8.11713 2.46484C7.75027 2.46484 7.45287 2.76224 7.45287 3.1291C7.45287 3.31586 7.52994 3.48461 7.654 3.60529Z", fill: "currentColor" })));
};



;// CONCATENATED MODULE: ../../../packages/hermes-booking-calendar/lib/icons/Call.esm.js


const Call = () => {
    return (react.createElement("svg", { width: "21", height: "20", viewBox: "0 0 21 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        react.createElement("path", { d: "M9.00526 5.00922L6.87446 2.87842C6.48683 2.4908 5.8594 2.4875 5.46772 2.87102L4.96817 3.36017C3.02778 5.26016 2.95416 8.36687 4.85747 10.304C6.74557 12.2257 8.58644 14.0214 10.5885 15.9491C12.5527 17.8404 15.6736 17.8006 17.5959 15.8666L18.115 15.3444C18.5036 14.9535 18.5026 14.322 18.1129 13.9323L15.7413 11.5607C15.3508 11.1702 14.7176 11.1702 14.3271 11.5607L13.2758 12.612C12.912 12.9757 12.3298 13.0042 11.937 12.672C9.95574 10.9967 9.18956 10.1025 8.0588 8.78264L8.01365 8.72994C7.67205 8.33125 7.69303 7.73567 8.06428 7.36442L9.00526 6.42344C9.39578 6.03291 9.39578 5.39975 9.00526 5.00922Z", stroke: "currentColor", strokeWidth: "1.2" }),
        react.createElement("path", { d: "M6.40039 5.36523L8.03044 6.95488", stroke: "currentColor", strokeLinecap: "round" }),
        react.createElement("path", { d: "M4.98633 3.99609L5.37767 4.37774", stroke: "currentColor", strokeLinecap: "round" }),
        react.createElement("path", { d: "M15.1035 14.127L17.1236 16.147", stroke: "currentColor", strokeLinecap: "round" })));
};



;// CONCATENATED MODULE: ../../../packages/hermes-booking-calendar/lib/components/Button/ContactButton.esm.js





const BookButton = ({ disabled, label, onClick }) => (react.createElement(Button_esm/* default */.Z, { variant: "primary2", onClick: onClick, disabled: disabled },
    react.createElement(Call, null),
    react.createElement(Typography_esm/* default */.Z, { component: "span" }, label !== null && label !== void 0 ? label : 'Contact')));



;// CONCATENATED MODULE: ../../../packages/hermes-booking-calendar/lib/screens/PreviewCalendar/styles.esm.js




const styles_esm_ContentWrapper = (0,styled_esm/* default */.ZP)('div')({
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    maxWidth: '600px',
});
const ButtonsPanel = (0,styled_esm/* default */.ZP)('div')(({ theme }) => (Object.assign({ display: 'flex', gap: '8px' }, theme.resolveThemeStyles({
    wpa: {
        flexDirection: 'row-reverse',
    },
}))));
const MobileFixedContactRequestPanel = (0,styled_esm/* default */.ZP)('div')(({ theme }) => ({
    position: 'fixed',
    bottom: 0,
    left: 0,
    display: 'none',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    zIndex: 999,
    gap: '40px',
    backgroundColor: theme.palette.background.light3,
    padding: '15px',
    borderTop: `solid thin ${theme.palette.grey[600]}`,
    borderBottom: `solid thin ${theme.palette.grey[600]}`,
    '@media (max-width: 480px)': {
        display: 'flex',
    },
}));
const DesktopContactRequestButton = (0,styled_esm/* default */.ZP)('div')({
    display: 'flex',
    width: '100%',
    '@media (max-width: 480px)': {
        display: 'none',
    },
});



;// CONCATENATED MODULE: ../../../packages/hermes-booking-calendar/lib/screens/DateSelection/styles.esm.js




const DateSelection_styles_esm_Container = (0,styled_esm/* default */.ZP)('div')({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    gap: '24px',
    '@media (max-width: 480px)': {
        gap: '18px',
    },
});
const FirstAvailableContainer = (0,styled_esm/* default */.ZP)('div')({
    display: 'flex',
    width: '100%',
});
const ExpandWrapper = (0,styled_esm/* default */.ZP)('div')(({ theme }) => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '8px',
    padding: '0 8px',
    color: theme.palette.system.navy900,
    cursor: 'pointer',
    userSelect: 'none',
}));
const Title = (0,styled_esm/* default */.ZP)('h2')(({ theme }) => ({
    display: 'flex',
    gap: '10px',
    margin: '0',
    width: '100%',
    color: theme.palette.text.darkNavy,
    fontFamily: `'Poppins', sans-serif`,
    fontSize: '24px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '32px',
    [theme.breakpoints.down('sm')]: {
        fontSize: '18px',
    },
}));



;// CONCATENATED MODULE: ../../../packages/hermes-booking-calendar/lib/views/BookingInfo/styles.esm.js


const ProfileInfoWrapper = (0,styled_esm/* default */.ZP)('div')({
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
});
const ProfileLogo = (0,styled_esm/* default */.ZP)('img')({
    borderRadius: '6px',
    width: '54px',
    height: '54px',
});
const BookingInfoWrapper = (0,styled_esm/* default */.ZP)('div')({
    display: 'flex',
    flexDirection: 'column',
});
const ProfileNameText = (0,styled_esm/* default */.ZP)('span')(({ theme }) => ({
    color: theme.palette.text.darkNavy,
    fontFamily: `'Poppins', sans-serif`,
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '24px',
}));
const SecondaryText = (0,styled_esm/* default */.ZP)('span')(({ theme }) => ({
    color: theme.palette.text.secondary,
    fontFamily: `'Poppins', sans-serif`,
    fontSize: '13px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '20px',
}));



;// CONCATENATED MODULE: ../../../packages/hermes-booking-calendar/lib/components/SlotSelection/styles.esm.js


const SlotSelection_styles_esm_Container = (0,styled_esm/* default */.ZP)('div')({
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
});
const TextItem = (0,styled_esm/* default */.ZP)('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    width: '100%',
    color: theme.palette.text.secondary,
    fontFamily: `'Poppins', sans-serif`,
    fontSize: '14px',
    fontStyle: 'normal',
    fontHeight: 400,
    lineHeight: '20px',
    '&>span>b': Object.assign({}, theme.resolveThemeStyles({
        default: {
            fontWeight: 600,
        },
        wpa: {
            fontWeight: 500,
        },
    })),
}));
const TimesContent = (0,styled_esm/* default */.ZP)('div')({
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
});
const DateTimeSection = (0,styled_esm/* default */.ZP)('div')({
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
});
const DateLabel = (0,styled_esm/* default */.ZP)('label')(({ theme }) => (Object.assign({ color: theme.palette.text.darkNavy, fontFamily: `'Poppins', sans-serif`, fontSize: '16px', fontStyle: 'normal', lineHeight: '24px' }, theme.resolveThemeStyles({
    default: {
        fontWeight: 600,
    },
    wpa: {
        fontWeight: 500,
    },
}))));
const TimesWrapper = (0,styled_esm/* default */.ZP)('div')({
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(78px, 1fr))',
    gap: '8px',
});



;// CONCATENATED MODULE: ../../../packages/hermes-booking-calendar/lib/components/Calendar/styles.esm.js


const CalendarNavigationButton = (0,styled_esm/* default */.ZP)('button')({
    cursor: 'pointer',
    background: 'none',
    border: 'none',
    outline: 'none',
    '&:disabled': {
        pointerEvents: 'none',
        cursor: 'none',
    },
});
const Calendar_styles_esm_Container = (0,styled_esm/* default */.ZP)(Box_esm/* default */.Z)({
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
    width: '100%',
    '@media (max-width: 480px)': {
        gap: '16px',
    },
});
const CalendarNavigationContainer = (0,styled_esm/* default */.ZP)(Box_esm/* default */.Z)(({ theme }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    userSelect: 'none',
    padding: '0 3%',
    color: theme.palette.text.darkNavy,
    textAlign: 'center',
    fontFamily: `'Poppins', sans-serif`,
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '140%',
    '&>span': {
        fontWeight: 600,
    },
    '@media (max-width: 480px)': {
        padding: 0,
    },
}));
const CalendarContent = (0,styled_esm/* default */.ZP)(Box_esm/* default */.Z)(({ cols }) => ({
    display: 'grid',
    gridTemplateColumns: `repeat(${cols !== null && cols !== void 0 ? cols : 7}, 1fr)`,
    width: '100%',
    gap: '24px',
    '@media (max-width: 480px)': {
        gap: '16px !important',
    },
}));
const PreviousMonthButton = (0,styled_esm/* default */.ZP)(CalendarNavigationButton)({
    transform: 'rotate(90deg)',
});
const NextMonthButton = (0,styled_esm/* default */.ZP)(CalendarNavigationButton)({
    transform: 'rotate(-90deg)',
});
const Cell = (0,styled_esm/* default */.ZP)(Box_esm/* default */.Z)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.palette.text.secondary,
    textAlign: 'center',
    fontFamily: `'Poppins', sans-serif`,
    fontSize: '13.33px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: 'normal',
    textTransform: 'uppercase',
}));
const ExpandedCalendarContainer = (0,styled_esm/* default */.ZP)(Box_esm/* default */.Z)({
    display: 'flex',
    gap: '10%',
    marginTop: '16px',
    width: '100%',
});
const ExpandedCalendarSide = (0,styled_esm/* default */.ZP)(Box_esm/* default */.Z)({
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
    flex: 1,
});



;// CONCATENATED MODULE: ../../../packages/hermes-booking-calendar/lib/screens/PreviewCalendar/index.esm.js




















const DISPLAY_DAYS_NUMBER = 5;
const DISPLAY_SLOTS_NUMBER = 3;
const PreviewCalendar = ({ practiceProfile, specialistProfile, timeSlots, onLocationChange, onDateSelect, onSlotSelect, onCalendarOpen, onSlotsOpen, onContactClick, onViewAllAvailabilityClick, displayMobileContactPanel, displayLocationDropdown, hideTitle = false, }) => {
    var _a, _b, _c;
    const activeDate = (0,react.useMemo)(() => { var _a; return getWithTimezoneOffset(new Date((_a = timeSlots === null || timeSlots === void 0 ? void 0 : timeSlots[0]) === null || _a === void 0 ? void 0 : _a.date)); }, [timeSlots]);
    const year = (0,react.useMemo)(() => activeDate.getFullYear(), [activeDate]);
    const month = (0,react.useMemo)(() => activeDate.getMonth(), [activeDate]);
    const days = (0,react.useMemo)(() => generateDaysForMonth(year, month), [year, month]);
    const selectableDates = (0,react.useMemo)(() => timeSlots.map((ts) => ts.date), [timeSlots]);
    const firstAvailableDate = (0,react.useMemo)(() => {
        var _a, _b;
        return (_b = (_a = days.find((day) => (selectableDates === null || selectableDates === void 0 ? void 0 : selectableDates[0]) === formatDate(day.date))) === null || _a === void 0 ? void 0 : _a.date) !== null && _b !== void 0 ? _b : getWithTimezoneOffset(new Date());
    }, [selectableDates, days]);
    const lastDisplayDate = (0,react.useMemo)(() => {
        const lastDate = new Date(firstAvailableDate);
        lastDate.setDate(lastDate.getDate() + DISPLAY_DAYS_NUMBER);
        return lastDate;
    }, [firstAvailableDate]);
    const [selectedDate, setSelectedDate] = (0,react.useState)();
    const [selectedSlot, setSelectedSlot] = (0,react.useState)();
    const dayNames = (0,react.useMemo)(() => ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'], []);
    const displayDays = (0,react.useMemo)(() => {
        const firstDayName = firstAvailableDate.toLocaleDateString(DATE_LOCALE, {
            weekday: 'short',
        });
        let index = dayNames.indexOf(firstDayName);
        const result = [];
        for (let i = 0; i < DISPLAY_DAYS_NUMBER; i++) {
            const dayName = dayNames[index];
            index = (index + 1) % dayNames.length;
            result.push(dayName);
        }
        return result;
    }, [firstAvailableDate, dayNames]);
    const slotsToDisplay = (0,react.useMemo)(() => {
        let displaySlots = timeSlots
            .filter((f) => f.date === formatDate(selectedDate !== null && selectedDate !== void 0 ? selectedDate : activeDate))
            .slice(0, DISPLAY_SLOTS_NUMBER);
        return displaySlots;
    }, [selectedDate, activeDate]);
    const handleDateSelect = (0,react.useCallback)((date) => {
        setSelectedDate(date);
        onDateSelect === null || onDateSelect === void 0 ? void 0 : onDateSelect(formatDate(date));
    }, []);
    const handleSlotSelect = (0,react.useCallback)((slot) => {
        setSelectedSlot(slot);
        onSlotSelect === null || onSlotSelect === void 0 ? void 0 : onSlotSelect(slot);
    }, []);
    return (react.createElement(styles_esm_ContentWrapper, { style: { gap: '8px' } },
        !hideTitle ? (react.createElement(Title, { style: { fontSize: 20, marginBottom: 10 } }, "Book an appointment")) : null,
        displayLocationDropdown ? (react.createElement(TextItem, null,
            react.createElement(FirstAvailable, null),
            react.createElement("span", null, "First available appointment at:"))) : null,
        react.createElement(styles_esm_ContentWrapper, { style: { gap: '16px' } },
            react.createElement(LocationDropdown, { disabled: !displayLocationDropdown, label: (_a = practiceProfile === null || practiceProfile === void 0 ? void 0 : practiceProfile.name) !== null && _a !== void 0 ? _a : '', rating: (_b = practiceProfile === null || practiceProfile === void 0 ? void 0 : practiceProfile.rating) !== null && _b !== void 0 ? _b : 0, reviewsNumber: (_c = practiceProfile === null || practiceProfile === void 0 ? void 0 : practiceProfile.reviewsNumber) !== null && _c !== void 0 ? _c : 0, onClick: onLocationChange }),
            react.createElement(CalendarContent, { style: { gap: '20px' }, cols: DISPLAY_DAYS_NUMBER + 1 },
                displayDays.map((dayName, index) => (react.createElement(Cell, { key: index }, dayName))),
                react.createElement("span", null),
                days.map((day, index) => day.date >= firstAvailableDate && day.date < lastDisplayDate ? (react.createElement(Cell, { key: index },
                    react.createElement(DateItem, { sx: { height: 40, width: 40 }, value: String(day.date.getDate()), firstAvailable: (selectableDates === null || selectableDates === void 0 ? void 0 : selectableDates[0]) === formatDate(day.date), selected: (selectableDates === null || selectableDates === void 0 ? void 0 : selectableDates[0]) === formatDate(day.date), disabled: !selectableDates.find((f) => f === formatDate(day.date)), onClick: () => handleDateSelect(day.date) }))) : null),
                react.createElement(DateItem, { sx: {
                        height: 40,
                        width: 40,
                        backgroundColor: 'common.white',
                        color: 'primary.main',
                    }, value: react.createElement(ArrowRight, null), onClick: onCalendarOpen })),
            react.createElement(TimesContent, null,
                react.createElement(DateTimeSection, null,
                    react.createElement(TimesWrapper, null,
                        slotsToDisplay.map((slot, index) => (react.createElement(TimeItem, { sx: { visibility: slot ? 'visible' : 'hidden' }, key: index, onClick: () => handleSlotSelect(slot), value: slot === null || slot === void 0 ? void 0 : slot.time, selected: selectedSlot && selectedSlot.id === (slot === null || slot === void 0 ? void 0 : slot.id) }))),
                        react.createElement(TimeItem, { sx: { backgroundColor: 'common.white' }, onClick: onSlotsOpen, value: 'More' })))),
            react.createElement(ButtonsPanel, null,
                react.createElement(Button_esm/* default */.Z, { variant: "tertiary", onClick: onViewAllAvailabilityClick },
                    react.createElement(Typography_esm/* default */.Z, { component: "span" }, "View all")),
                react.createElement(DesktopContactRequestButton, null,
                    react.createElement(BookButton, { onClick: onContactClick })))),
        displayMobileContactPanel ? (react.createElement(MobileFixedContactRequestPanel, null,
            react.createElement("div", { style: { display: 'flex', flexDirection: 'column' } },
                react.createElement(ProfileNameText, { style: { fontSize: 15 } },
                    (specialistProfile === null || specialistProfile === void 0 ? void 0 : specialistProfile.title) && (react.createElement("span", null, specialistProfile === null || specialistProfile === void 0 ? void 0 :
                        specialistProfile.title,
                        " ")),
                    react.createElement("span", null, specialistProfile === null || specialistProfile === void 0 ? void 0 : specialistProfile.name)),
                react.createElement(SecondaryText, null,
                    react.createElement(RatingWrapper, { style: { fontWeight: 600 } },
                        react.createElement(Star, null),
                        react.createElement("span", null, specialistProfile === null || specialistProfile === void 0 ? void 0 : specialistProfile.rating),
                        react.createElement("span", null, "\u2022"),
                        react.createElement("span", null, specialistProfile === null || specialistProfile === void 0 ? void 0 :
                            specialistProfile.reviewsNumber,
                            " Reviews")))),
            react.createElement("div", null,
                react.createElement(BookButton, { onClick: onContactClick })))) : null));
};



;// CONCATENATED MODULE: ../../../packages/hermes-booking-calendar/lib/components/Calendar/index.esm.js







const EXPAND_CALENDAR_WIDTH = 955;
const dayNames = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
const formatDateYear = (date) => date.toLocaleString('en', { month: 'short', year: 'numeric' });
const Calendar = ({ selectableDates = [], onDateSelect, isExpanded, }) => {
    const firstAvailableDate = (0,react.useMemo)(() => {
        const currentDate = new Date();
        const firstAvailableDate = selectableDates.find((slotDate) => {
            const date = new Date(slotDate);
            return date >= currentDate;
        });
        return firstAvailableDate ? new Date(firstAvailableDate) : currentDate;
    }, [selectableDates]);
    const [activeDate, setActiveDate] = (0,react.useState)(firstAvailableDate);
    const [canExpand, setCanExpand] = (0,react.useState)(false);
    const activeDateNextMonth = (0,react.useMemo)(() => new Date(activeDate.getFullYear(), activeDate.getMonth() + 1, 1), [activeDate]);
    const handlePrevMonth = (0,react.useCallback)(() => {
        setActiveDate(new Date(activeDate.getFullYear(), activeDate.getMonth() - 1, 1));
    }, [activeDate]);
    const handleNextMonth = (0,react.useCallback)(() => {
        setActiveDate(new Date(activeDate.getFullYear(), activeDate.getMonth() + 1, 1));
    }, [activeDate]);
    const handleDateSelect = (0,react.useCallback)((date) => {
        onDateSelect === null || onDateSelect === void 0 ? void 0 : onDateSelect(formatDate(getWithTimezoneOffset(date)));
    }, [onDateSelect]);
    const currentMonthDays = (0,react.useMemo)(() => {
        const currentMonthYear = activeDate.getFullYear();
        const currentMonth = activeDate.getMonth();
        return generateDaysForMonth(currentMonthYear, currentMonth);
    }, [activeDate]);
    const nextMonthDays = (0,react.useMemo)(() => {
        const nextMonthYear = activeDateNextMonth.getFullYear();
        const nextMonth = activeDateNextMonth.getMonth();
        return generateDaysForMonth(nextMonthYear, nextMonth);
    }, [activeDateNextMonth]);
    const containerRef = (0,react.useRef)(null);
    (0,react.useEffect)(() => {
        const container = containerRef.current;
        const handleResize = (entries) => {
            for (let entry of entries) {
                setCanExpand(entry.contentRect.width >= EXPAND_CALENDAR_WIDTH);
            }
        };
        const resizeObserver = new ResizeObserver(handleResize);
        if (container) {
            resizeObserver.observe(container);
        }
        return () => {
            if (container) {
                resizeObserver.unobserve(container);
            }
        };
    }, []);
    const renderCalendarContent = (0,react.useCallback)((monthDays) => (react.createElement(react.Fragment, null,
        dayNames.map((dayName) => (react.createElement(Cell, { key: dayName }, dayName))),
        monthDays.map((day) => (react.createElement(Cell, { key: formatDate(day.date) }, day.isCurrentMonth ? (react.createElement(DateItem, { sx: isExpanded ? { width: 40, height: 40 } : {}, value: String(day.date.getDate()), firstAvailable: (selectableDates === null || selectableDates === void 0 ? void 0 : selectableDates[0]) === formatDate(day.date), selected: (selectableDates === null || selectableDates === void 0 ? void 0 : selectableDates[0]) === formatDate(day.date), disabled: !selectableDates.find((f) => f === formatDate(day.date)), onClick: () => handleDateSelect(day.date) })) : null))))), [selectableDates, isExpanded]);
    return (react.createElement(Calendar_styles_esm_Container, { ref: containerRef }, isExpanded && canExpand ? (react.createElement(ExpandedCalendarContainer, null,
        react.createElement(ExpandedCalendarSide, null,
            react.createElement(CalendarNavigationContainer, null,
                react.createElement(PreviousMonthButton, { disabled: activeDate.getMonth() === firstAvailableDate.getMonth() &&
                        activeDate.getFullYear() === firstAvailableDate.getFullYear(), onClick: handlePrevMonth },
                    react.createElement(Caret, null)),
                react.createElement("span", null, formatDateYear(activeDate)),
                react.createElement("div", null)),
            react.createElement(CalendarContent, null, renderCalendarContent(currentMonthDays))),
        react.createElement(ExpandedCalendarSide, null,
            react.createElement(CalendarNavigationContainer, null,
                react.createElement("div", null),
                react.createElement("span", null, formatDateYear(activeDateNextMonth)),
                react.createElement(NextMonthButton, { onClick: handleNextMonth },
                    react.createElement(Caret, null))),
            react.createElement(CalendarContent, null, renderCalendarContent(nextMonthDays))))) : (react.createElement(react.Fragment, null,
        react.createElement(CalendarNavigationContainer, null,
            react.createElement(PreviousMonthButton, { disabled: activeDate.getMonth() === firstAvailableDate.getMonth(), onClick: handlePrevMonth },
                react.createElement(Caret, null)),
            react.createElement("span", null, formatDateYear(activeDate)),
            react.createElement(NextMonthButton, { onClick: handleNextMonth },
                react.createElement(Caret, null))),
        react.createElement(CalendarContent, null, renderCalendarContent(currentMonthDays))))));
};



;// CONCATENATED MODULE: ../../../packages/hermes-booking-calendar/lib/views/StepFooter/styles.esm.js


const StepFooter_styles_esm_Container = (0,styled_esm/* default */.ZP)('div')(({ theme }) => (Object.assign(Object.assign({ position: 'relative', display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '16px', boxSizing: 'content-box', padding: '16px 8px' }, theme.resolveThemeStyles({
    default: {
        backgroundColor: theme.palette.background.default,
    },
    wpa: {
        backgroundColor: theme.palette.blue[200],
    },
})), { width: '100%', borderTop: `solid thin ${theme.palette.grey[600]}`, borderBottom: `solid thin ${theme.palette.grey[600]}`, '&::before, &::after': {
        content: '""',
        position: 'absolute',
        height: '100%',
        width: '100%',
        backgroundColor: 'inherit',
        border: 'inherit',
    }, '&::before': {
        left: 'calc(-100%)',
    }, '&::after': {
        right: 'calc(-100%)',
    }, '@media (max-width: 480px)': {
        padding: '16px 0',
    } })));



;// CONCATENATED MODULE: ../../../packages/hermes-booking-calendar/lib/views/BookingInfo/index.esm.js



const BookingInfo = ({ specialistProfile, practiceProfile, dateString, timeString, }) => {
    return (react.createElement(ProfileInfoWrapper, null,
        react.createElement(ProfileLogo, { src: specialistProfile === null || specialistProfile === void 0 ? void 0 : specialistProfile.imageSrc, alt: '' }),
        react.createElement(BookingInfoWrapper, null,
            react.createElement(ProfileNameText, null, specialistProfile === null || specialistProfile === void 0 ? void 0 : specialistProfile.name),
            (practiceProfile === null || practiceProfile === void 0 ? void 0 : practiceProfile.name) && (react.createElement(SecondaryText, null, practiceProfile.name)),
            react.createElement(SecondaryText, null,
                dateString && react.createElement("span", null, dateString),
                timeString && react.createElement("span", null,
                    " at ",
                    timeString)))));
};



;// CONCATENATED MODULE: ../../../packages/hermes-booking-calendar/lib/views/StepFooter/index.esm.js





const StepFooter = ({ specialistProfile, practiceProfile, dateString, timeString, }) => {
    return (react.createElement(StepFooter_styles_esm_Container, null,
        react.createElement(BookingInfo, { specialistProfile: specialistProfile, practiceProfile: practiceProfile, dateString: formatDateStringToDisplay(dateString), timeString: formatTimeStringToDisplay(timeString) })));
};



;// CONCATENATED MODULE: ../../../packages/hermes-booking-calendar/lib/components/StickyBottomContainer/styles.esm.js


const StickyBottomContainer_styles_esm_Container = (0,styled_esm/* default */.ZP)('div')({
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    height: '100%',
    width: '100%',
});
const StickyComponent = (0,styled_esm/* default */.ZP)('div')({
    position: 'sticky',
    width: '100%',
    bottom: 0,
});



;// CONCATENATED MODULE: ../../../packages/hermes-booking-calendar/lib/components/StickyBottomContainer/index.esm.js



const StickyBottomContainer = ({ children, stickyComponent, }) => {
    return (react.createElement(StickyBottomContainer_styles_esm_Container, null,
        children,
        react.createElement(StickyComponent, null, stickyComponent)));
};



;// CONCATENATED MODULE: ../../../packages/hermes-booking-calendar/lib/hooks/useIsDesktop.esm.js


const useIsDesktop = () => {
    const [isDesktop, setIsDesktop] = (0,react.useState)(window.matchMedia('(min-width: 955px)').matches);
    (0,react.useEffect)(() => {
        const mediaQuery = window.matchMedia('(min-width: 955px)');
        const handleChange = () => setIsDesktop(mediaQuery.matches);
        mediaQuery.addEventListener('change', handleChange);
        return () => {
            mediaQuery.removeEventListener('change', handleChange);
        };
    }, []);
    return isDesktop;
};



;// CONCATENATED MODULE: ../../../packages/hermes-booking-calendar/lib/icons/Expand.esm.js


const Expand = () => {
    return (react.createElement("svg", { width: "17", height: "17", viewBox: "0 0 17 17", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        react.createElement("path", { d: "M6.90107 6.92862C7.13527 7.16305 7.51517 7.16322 7.74959 6.92902C7.98402 6.69482 7.9842 6.31492 7.74999 6.08049L6.90107 6.92862ZM7.74999 6.08049L3.79946 2.12623L2.95054 2.97436L6.90107 6.92862L7.74999 6.08049Z", fill: "currentColor" }),
        react.createElement("path", { d: "M3.3584 6.50456V2.55029H7.23305", stroke: "currentColor", strokeWidth: "1.2", strokeLinecap: "round", strokeLinejoin: "round" }),
        react.createElement("path", { d: "M10.8528 9.19443C10.6186 8.96 10.2387 8.95982 10.0043 9.19403C9.76989 9.42823 9.76971 9.80813 10.0039 10.0426L10.8528 9.19443ZM10.0039 10.0426L13.9544 13.9968L14.8034 13.1487L10.8528 9.19443L10.0039 10.0426Z", fill: "currentColor" }),
        react.createElement("path", { d: "M14.3955 9.61849L14.3955 13.5728L10.5209 13.5728", stroke: "currentColor", strokeWidth: "1.2", strokeLinecap: "round", strokeLinejoin: "round" }),
        react.createElement("path", { d: "M10.0172 6.08661C9.78276 6.32082 9.78258 6.70072 10.0168 6.93514C10.251 7.16957 10.6309 7.16975 10.8653 6.93554L10.0172 6.08661ZM10.8653 6.93554L14.8196 2.98501L13.9714 2.13608L10.0172 6.08661L10.8653 6.93554Z", fill: "currentColor" }),
        react.createElement("path", { d: "M10.4412 2.5437L14.3955 2.5437L14.3955 6.41836", stroke: "currentColor", strokeWidth: "1.2", strokeLinecap: "round", strokeLinejoin: "round" }),
        react.createElement("path", { d: "M7.73673 10.0364C7.97115 9.80223 7.97133 9.42233 7.73713 9.18791C7.50292 8.95348 7.12302 8.9533 6.8886 9.18751L7.73673 10.0364ZM6.8886 9.18751L2.93433 13.138L3.78246 13.987L7.73673 10.0364L6.8886 9.18751Z", fill: "currentColor" }),
        react.createElement("path", { d: "M7.31266 13.5793L3.3584 13.5793L3.3584 9.70469", stroke: "currentColor", strokeWidth: "1.2", strokeLinecap: "round", strokeLinejoin: "round" })));
};



;// CONCATENATED MODULE: ../../../packages/hermes-booking-calendar/lib/icons/ArrowBack.esm.js



const ArrowBackWrapper = (0,styled_esm/* default */.ZP)('div')(({ theme }) => ({
    [theme.breakpoints.down('sm')]: {
        paddingTop: '2px',
    },
}));
const ArrowBack = () => {
    return (react.createElement(ArrowBackWrapper, null,
        react.createElement("svg", { width: "18", height: "18", viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            react.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.77095 15.6634L9.77328 15.661L4.19328 10.071L16.3633 10.071C16.9156 10.071 17.3633 9.62331 17.3633 9.07102C17.3633 8.51874 16.9156 8.07102 16.3633 8.07102L4.19328 8.07102L9.77328 2.48102L9.77142 2.47916C9.96589 2.29733 10.0874 2.03847 10.0874 1.75123C10.0874 1.20094 9.64133 0.75484 9.09104 0.75484C8.80141 0.75484 8.54064 0.878416 8.35859 1.07572L0.363281 9.07102L8.329 17.0367C8.51157 17.2436 8.77868 17.374 9.07626 17.374C9.62655 17.374 10.0726 16.9279 10.0726 16.3776C10.0726 16.0975 9.95705 15.8444 9.77095 15.6634Z", fill: "currentColor" }))));
};



;// CONCATENATED MODULE: ../../../packages/hermes-booking-calendar/lib/screens/DateSelection/index.esm.js














const DateSelection = ({ selectableDates, onDateSelect, onNextStep, onCalendarExpandClick, onLocationChange, onBackButtonClick, bookingInfo, expandedView, displayLocationDropdown, }) => {
    var _a, _b, _c, _d, _e;
    const [selectedDate, setSelectedDate] = (0,react.useState)();
    const [isExpanded, setIsExpanded] = (0,react.useState)(expandedView);
    const isDesktop = useIsDesktop();
    const firstAvailableDate = (0,react.useMemo)(() => getWithTimezoneOffset(new Date(selectableDates === null || selectableDates === void 0 ? void 0 : selectableDates[0])).toLocaleDateString(DATE_LOCALE, {
        weekday: 'short',
        day: 'numeric',
    }), [selectableDates]);
    const handleDateSelect = (0,react.useCallback)((date) => {
        setSelectedDate(date);
        onDateSelect === null || onDateSelect === void 0 ? void 0 : onDateSelect(date);
        onNextStep === null || onNextStep === void 0 ? void 0 : onNextStep();
    }, [onDateSelect, onNextStep]);
    const handleExpandClick = (0,react.useCallback)(() => {
        onCalendarExpandClick === null || onCalendarExpandClick === void 0 ? void 0 : onCalendarExpandClick();
        setIsExpanded((prev) => !prev);
    }, [onCalendarExpandClick]);
    return (react.createElement(StickyBottomContainer, { stickyComponent: react.createElement(StepFooter, Object.assign({}, bookingInfo, { dateString: selectedDate })) },
        react.createElement(DateSelection_styles_esm_Container, { style: { marginBottom: '24px' } },
            react.createElement(Title, null,
                react.createElement("div", { style: { cursor: 'pointer' }, onClick: onBackButtonClick },
                    react.createElement(ArrowBack, null)),
                react.createElement("span", null, "Select a date")),
            react.createElement(LocationDropdown, { disabled: !displayLocationDropdown, onClick: onLocationChange, label: (_b = (_a = bookingInfo === null || bookingInfo === void 0 ? void 0 : bookingInfo.practiceProfile) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : '', rating: (_d = (_c = bookingInfo === null || bookingInfo === void 0 ? void 0 : bookingInfo.practiceProfile) === null || _c === void 0 ? void 0 : _c.rating) !== null && _d !== void 0 ? _d : 0, reviewsNumber: (_e = bookingInfo === null || bookingInfo === void 0 ? void 0 : bookingInfo.practiceProfile) === null || _e === void 0 ? void 0 : _e.reviewsNumber }),
            react.createElement(FirstAvailableContainer, { style: { marginBottom: 10 } },
                react.createElement(TextItem, null,
                    react.createElement(FirstAvailable, null),
                    react.createElement("span", null,
                        "First available appointment: ",
                        react.createElement("b", null, firstAvailableDate))),
                isDesktop && onCalendarExpandClick ? (react.createElement(ExpandWrapper, { onClick: handleExpandClick },
                    react.createElement("span", null, isExpanded ? 'Minimize' : 'Expand'),
                    react.createElement(Expand, null))) : null),
            react.createElement(Calendar, { isExpanded: isExpanded, selectableDates: selectableDates, onDateSelect: handleDateSelect }))));
};



;// CONCATENATED MODULE: ../../../packages/hermes-booking-calendar/lib/components/SlotSelection/utils.esm.js



const groupSlotsByDate = (timeSlots) => timeSlots
    .map((slot) => ({
    dateTime: new Date(`${slot.date} ${slot.time}`),
    originalSlot: slot,
}))
    .sort((a, b) => sortDatesFn(a.dateTime, b.dateTime))
    .map(({ originalSlot }) => originalSlot)
    .reduce((p, slot) => {
    const dateString = getWithTimezoneOffset(new Date(slot.date)).toLocaleDateString(DATE_LOCALE, {
        weekday: 'long',
        day: 'numeric',
        month: 'long',
    });
    if (!p[dateString]) {
        p[dateString] = [];
    }
    p[dateString].push({
        dateString,
        slot: slot,
    });
    return p;
}, {});



;// CONCATENATED MODULE: ../../../packages/hermes-booking-calendar/lib/components/SlotSelection/index.esm.js








const SlotSelection = ({ timeSlots = [], onSlotSelect, }) => {
    const [selectedSlot, setSelectedSlot] = (0,react.useState)();
    const slotsGroupedByDate = (0,react.useMemo)(() => groupSlotsByDate(timeSlots), [timeSlots]);
    const firstSlot = (0,react.useMemo)(() => {
        var _a, _b;
        const firstKey = (_a = Object.keys(slotsGroupedByDate)) === null || _a === void 0 ? void 0 : _a[0];
        if (!firstKey) {
            return null;
        }
        return (_b = slotsGroupedByDate[firstKey]) === null || _b === void 0 ? void 0 : _b[0].slot;
    }, [slotsGroupedByDate]);
    const firstAvailableDateTime = (0,react.useMemo)(() => {
        if (!firstSlot) {
            return null;
        }
        const firstSlotDateTime = new Date(`${firstSlot.date} ${firstSlot.time}`);
        return `${firstSlotDateTime.toLocaleDateString(DATE_LOCALE, {
            weekday: 'short',
            day: 'numeric',
        })}, ${formatTime(firstSlotDateTime)}`;
    }, [firstSlot]);
    const handleSlotSelect = (slot) => {
        setSelectedSlot(slot);
        onSlotSelect === null || onSlotSelect === void 0 ? void 0 : onSlotSelect(slot);
    };
    return (react.createElement(SlotSelection_styles_esm_Container, null,
        firstAvailableDateTime ? (react.createElement(TextItem, { style: { marginBottom: '24px' } },
            react.createElement(FirstAvailable, null),
            react.createElement("span", null,
                "First available appointment: ",
                react.createElement("b", null, firstAvailableDateTime)))) : null,
        react.createElement(TimesContent, null, Object.keys(slotsGroupedByDate).map((date, index) => (react.createElement(DateTimeSection, { key: index },
            react.createElement(DateLabel, null, date),
            react.createElement(TimesWrapper, null, slotsGroupedByDate[date].map(({ slot }, index) => (react.createElement(TimeItem, { key: index, onClick: () => handleSlotSelect(slot), value: slot.time, firstAvailable: (firstSlot === null || firstSlot === void 0 ? void 0 : firstSlot.id) === slot.id, selected: selectedSlot && selectedSlot.id === slot.id }))))))))));
};



;// CONCATENATED MODULE: ../../../packages/hermes-booking-calendar/lib/screens/SlotSelection/styles.esm.js


const screens_SlotSelection_styles_esm_Container = (0,styled_esm/* default */.ZP)('div')({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    gap: '24px',
});
(0,styled_esm/* default */.ZP)('h2')(({ theme }) => ({
    margin: '0',
    width: '100%',
    color: theme.palette.text.darkNavy,
    fontFamily: `'Poppins', sans-serif`,
    fontSize: '24px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '32px',
}));



;// CONCATENATED MODULE: ../../../packages/hermes-booking-calendar/lib/screens/SlotSelection/index.esm.js









const NEXT_DATES_NUMBER = 14;
const index_esm_SlotSelection = ({ timeSlots, onSlotSelect, onNextStep, onLocationChange, onBackButtonClick, bookingInfo, displayLocationDropdown, }) => {
    var _a, _b, _c, _d, _e, _f;
    const [selectedSlot, setSelectedSlot] = (0,react.useState)();
    const handleSlotSelect = (0,react.useCallback)((slot) => {
        setSelectedSlot(slot);
        onSlotSelect === null || onSlotSelect === void 0 ? void 0 : onSlotSelect(slot);
        onNextStep === null || onNextStep === void 0 ? void 0 : onNextStep();
    }, [onSlotSelect]);
    const selectedTimeString = (0,react.useMemo)(() => (selectedSlot ? selectedSlot.time : ''), [selectedSlot]);
    const filteredSlots = (0,react.useMemo)(() => {
        if (bookingInfo.dateString) {
            return timeSlots.filter((f) => {
                const slotDate = new Date(f.date);
                const selectedDate = new Date(bookingInfo.dateString);
                const maxDate = new Date(selectedDate);
                maxDate.setDate(maxDate.getDate() + NEXT_DATES_NUMBER);
                return slotDate >= selectedDate && slotDate <= maxDate;
            });
        }
        return timeSlots;
    }, [timeSlots, bookingInfo]);
    return (react.createElement(StickyBottomContainer, { stickyComponent: react.createElement(StepFooter, Object.assign({}, bookingInfo, { dateString: bookingInfo.dateString, timeString: selectedTimeString })) },
        react.createElement(screens_SlotSelection_styles_esm_Container, { style: { marginBottom: '24px' } },
            react.createElement(Title, null,
                react.createElement("div", { style: { cursor: 'pointer' }, onClick: onBackButtonClick },
                    react.createElement(ArrowBack, null)),
                react.createElement("span", null, "Select a time")),
            react.createElement(LocationDropdown, { disabled: !displayLocationDropdown, onClick: onLocationChange, label: (_b = (_a = bookingInfo === null || bookingInfo === void 0 ? void 0 : bookingInfo.practiceProfile) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : '', rating: (_d = (_c = bookingInfo === null || bookingInfo === void 0 ? void 0 : bookingInfo.practiceProfile) === null || _c === void 0 ? void 0 : _c.rating) !== null && _d !== void 0 ? _d : 0, reviewsNumber: (_f = (_e = bookingInfo === null || bookingInfo === void 0 ? void 0 : bookingInfo.practiceProfile) === null || _e === void 0 ? void 0 : _e.reviewsNumber) !== null && _f !== void 0 ? _f : 0 }),
            react.createElement(SlotSelection, { timeSlots: filteredSlots, onSlotSelect: handleSlotSelect }))));
};



;// CONCATENATED MODULE: ../../../packages/hermes-booking-calendar/lib/components/FormItem/styles.esm.js


const FormItem_styles_esm_Container = (0,styled_esm/* default */.ZP)('div')({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '8px',
    width: '100%',
    minWidth: '340px',
});
const styles_esm_Label = (0,styled_esm/* default */.ZP)('label')(({ theme, disabled, required }) => {
    let color;
    if (disabled) {
        color = theme.palette.grey[500];
    }
    else if (required) {
        color = theme.palette.text.primary;
    }
    else {
        color = theme.palette.text.primary;
    }
    return {
        fontFamily: `'Poppins', sans-serif`,
        fontSize: '13.33px',
        fontWeight: 400,
        lineHeight: '20px',
        textAlign: 'left',
        color,
        '&::after': required
            ? {
                content: '"*"',
                color: theme.palette.error.main,
                padding: '2px',
                fontSize: '13.33px',
            }
            : {},
    };
});
const InputWrapper = (0,styled_esm/* default */.ZP)('div')({
    width: '100%',
});
const InputError = (0,styled_esm/* default */.ZP)('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '10px',
    boxSizing: 'border-box',
    width: '100%',
    padding: '4px 8px',
    fontFamily: `'Poppins', sans-serif`,
    fontSize: '13.33px',
    fontWeight: 400,
    lineHeight: '20px',
    textAlign: 'left',
    color: theme.palette.system.coral900,
    backgroundColor: theme.palette.error.light,
}));
const Disclaimer = (0,styled_esm/* default */.ZP)('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '10px',
    boxSizing: 'border-box',
    width: '100%',
    padding: '4px 8px',
    fontFamily: `'Poppins', sans-serif`,
    fontSize: '13.33px',
    fontWeight: 400,
    lineHeight: '20px',
    textAlign: 'left',
    color: theme.palette.system.coral900,
}));
const ErrorText = (0,styled_esm/* default */.ZP)('span')({
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
});
const DisclaimerText = (0,styled_esm/* default */.ZP)('span')({
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    fontSize: '15px',
});



// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Grid/Grid.esm.js + 2 modules
var Grid_esm = __webpack_require__(54597);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/components/Tooltip/index.esm.js
var index_esm = __webpack_require__(63759);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/icons/InfoOutlined/index.esm.js
var InfoOutlined_index_esm = __webpack_require__(62646);
;// CONCATENATED MODULE: ../../../packages/hermes-booking-calendar/lib/icons/Warn.esm.js


const Warn = () => {
    return (react.createElement("svg", { width: "14", height: "21", viewBox: "0 0 14 21", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        react.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.25846 3.8335C3.57846 3.8335 0.591797 6.82016 0.591797 10.5002C0.591797 14.1802 3.57846 17.1668 7.25846 17.1668C10.9385 17.1668 13.9251 14.1802 13.9251 10.5002C13.9251 6.82016 10.9385 3.8335 7.25846 3.8335ZM7.25846 11.1668C6.8918 11.1668 6.5918 10.8668 6.5918 10.5002V7.8335C6.5918 7.46683 6.8918 7.16683 7.25846 7.16683C7.62513 7.16683 7.92513 7.46683 7.92513 7.8335V10.5002C7.92513 10.8668 7.62513 11.1668 7.25846 11.1668ZM6.5918 12.5002V13.8335H7.92513V12.5002H6.5918Z", fill: "currentColor" })));
};



;// CONCATENATED MODULE: ../../../packages/hermes-booking-calendar/lib/icons/Cross.esm.js


const Cross = () => {
    return (react.createElement("svg", { width: "11", height: "11", viewBox: "0 0 11 11", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        react.createElement("path", { d: "M10.2591 1.7735L9.31911 0.833496L5.59245 4.56016L1.86578 0.833496L0.925781 1.7735L4.65245 5.50016L0.925781 9.22683L1.86578 10.1668L5.59245 6.44016L9.31911 10.1668L10.2591 9.22683L6.53245 5.50016L10.2591 1.7735Z", fill: "currentColor" })));
};



;// CONCATENATED MODULE: ../../../packages/hermes-booking-calendar/lib/components/FormItem/index.esm.js







const FormItem = ({ label, inputComponent, disabled, errorMessage, required, onErrorClose, formFieldKey, hint, disclaimer, }) => {
    const inputWithProps = (0,react.cloneElement)(inputComponent, {
        disabled,
        isError: Boolean(errorMessage),
        required,
    });
    const handleCloseErrorMessage = (0,react.useCallback)(() => {
        if (onErrorClose) {
            onErrorClose(formFieldKey || '');
        }
    }, []);
    return (react.createElement(FormItem_styles_esm_Container, null,
        label ? (react.createElement(Grid_esm/* default */.ZP, { container: true, alignItems: "center", gap: "8px" },
            react.createElement(styles_esm_Label, { disabled: disabled, required: required }, label),
            !!(hint === null || hint === void 0 ? void 0 : hint.length) && (react.createElement(index_esm/* WhiteTooltip */.dp, { componentsProps: {
                    tooltip: {
                        sx: {
                            height: 'auto !important',
                            padding: '10px !important',
                        },
                    },
                }, title: hint },
                react.createElement(Grid_esm/* default */.ZP, { container: true, width: "auto" },
                    react.createElement(InfoOutlined_index_esm/* default */.Z, { sx: {
                            width: '16px',
                            height: '16px',
                        } })))))) : null,
        react.createElement(InputWrapper, null, inputWithProps),
        errorMessage ? (react.createElement(InputError, { className: 'form-input-error' },
            react.createElement(ErrorText, null,
                react.createElement(Warn, null),
                react.createElement("span", null, errorMessage)),
            react.createElement(Grid_esm/* default */.ZP, { container: true, width: "auto", onClick: handleCloseErrorMessage, sx: {
                    cursor: 'pointer',
                } },
                react.createElement(Cross, null)))) : null,
        disclaimer ? (react.createElement(Disclaimer, { style: { marginTop: '8px' } },
            react.createElement(DisclaimerText, null,
                react.createElement("span", null, disclaimer)))) : null));
};



;// CONCATENATED MODULE: ../../../packages/hermes-booking-calendar/lib/components/FormInput/styles.esm.js


const FormInput_styles_esm_Container = (0,styled_esm/* default */.ZP)('div')(({ theme, disabled, error }) => {
    let baseBorder = `solid thin ${theme.palette.grey[600]}`;
    if (error) {
        baseBorder = `solid thin ${theme.palette.system.coral900}`;
    }
    if (disabled) {
        baseBorder = `solid thin ${theme.palette.divider}`;
    }
    return {
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        border: baseBorder,
        borderRadius: '32px',
        cursor: 'pointer',
        userSelect: 'none',
        pointerEvents: disabled ? 'none' : 'inherit',
        '&:hover': {
            border: disabled
                ? `solid thin ${theme.palette.divider}`
                : `solid thin ${theme.palette.blue[400]}`,
            '&>svg': {
                color: theme.palette.primary.main,
            },
        },
        '&:active, &:focus-within': {
            border: disabled
                ? `solid thin ${theme.palette.divider}`
                : `solid thin ${theme.palette.blue[300]}`,
            '&>svg': {
                color: disabled ? theme.palette.grey[500] : theme.palette.primary.main,
            },
        },
        '&>svg': {
            position: 'absolute',
            right: '20px',
            top: '50%',
            transform: 'translateY(-50%)',
        },
        '&>*': {
            color: disabled ? theme.palette.grey[500] : 'inherit',
        },
    };
});
const Select = (0,styled_esm/* default */.ZP)('div')(({ theme }) => ({
    padding: '13px 16px',
    borderRadius: '32px',
    fontFamily: `'Poppins', sans-serif`,
    fontSize: '15px',
    fontWeight: 400,
    lineHeight: '22.5px',
    textAlign: 'left',
    border: 'none',
    color: theme.palette.text.primary,
    width: '100%',
    outline: 'none',
}));
const Options = (0,styled_esm/* default */.ZP)('div')(({ theme, isOpen }) => ({
    position: 'absolute',
    top: 'calc(100% + 5px)',
    left: '0',
    width: '100%',
    background: theme.palette.common.white,
    border: `solid thin ${theme.palette.grey[600]}`,
    borderRadius: '8px',
    zIndex: 10,
    boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
    maxHeight: '250px',
    overflowY: 'auto',
    display: isOpen ? 'block' : 'none',
}));
const Option = (0,styled_esm/* default */.ZP)('div')(({ theme }) => ({
    fontFamily: `'Poppins', sans-serif`,
    padding: '12px 16px',
    cursor: 'pointer',
    backgroundColor: theme.palette.common.white,
    '&:hover': {
        backgroundColor: theme.palette.background.light,
    },
    '&.selected': {
        backgroundColor: theme.palette.background.light2,
    },
}));
const Input = (0,styled_esm/* default */.ZP)('input')(({ theme }) => ({
    padding: '13px 16px',
    borderRadius: '32px',
    fontFamily: `'Poppins', sans-serif`,
    fontSize: '15px',
    fontWeight: 400,
    lineHeight: '22.5px',
    textAlign: 'left',
    border: 'none',
    color: theme.palette.text.primary,
    width: '100%',
    outline: 'none',
}));
const DOBContainer = (0,styled_esm/* default */.ZP)('div')({
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
});
const PhoneInputContainer = (0,styled_esm/* default */.ZP)(FormInput_styles_esm_Container)(({ theme }) => ({
    '& .DialCode': {
        position: 'absolute',
        left: '28px',
        pointerEvents: 'none',
    },
    '& .PhoneInput': {
        display: 'flex',
        borderRadius: '32px',
        border: 'none',
        width: '100%',
        outline: 'none',
        '&>input': {
            fontFamily: `'Poppins', sans-serif`,
            fontSize: '15px',
            fontWeight: 400,
            lineHeight: '22.5px',
            textAlign: 'left',
            color: theme.palette.text.primary,
            width: '100%',
            height: '48px',
            padding: '0 16px',
            border: 'none',
            outline: 'none',
            borderRadius: '0 32px 32px 0',
        },
    },
    '& .PhoneInputCountry': {
        display: 'flex',
        position: 'relative,',
        '& .PhoneInputCountrySelect': {
            maxWidth: '64px',
            border: 'none',
            outline: 'none',
            borderRadius: '32px 0 0 32px',
            backgroundColor: theme.palette.grey[600],
            color: 'transparent',
            '&>option': {
                color: '#000',
            },
        },
    },
    '& .PhoneInputCountryIcon': {
        position: 'absolute',
        left: '17px',
        top: '50%',
        width: '30px',
        height: '20px',
        transform: 'translateY(-50%)',
        pointerEvents: 'none',
    },
}));



;// CONCATENATED MODULE: ../../../packages/hermes-booking-calendar/lib/hooks/useClickOutside.esm.js


const useOnClickOutside = (ref, handler) => {
    (0,react.useEffect)(() => {
        const handleClickOutside = (event) => {
            if (ref.current &&
                event.target instanceof Node &&
                !ref.current.contains(event.target)) {
                handler === null || handler === void 0 ? void 0 : handler();
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        document.addEventListener('touchstart', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
            document.removeEventListener('touchstart', handleClickOutside);
        };
    }, [handler, ref]);
};



;// CONCATENATED MODULE: ../../../packages/hermes-booking-calendar/lib/components/FormInput/Dropdown.esm.js





const LETTER_REGEXP = /^[a-zA-Z]$/;
const Dropdown = ({ items, selected, onChange, validate, disabled, isError, }) => {
    const [isOpen, setIsOpen] = (0,react.useState)(false);
    const [currentSelected, setCurrentSelected] = (0,react.useState)(selected || items[0]);
    const dropdownRef = (0,react.useRef)(null);
    const optionsRef = (0,react.useRef)(null);
    const toggleDropdown = (0,react.useCallback)(() => {
        if (!disabled) {
            setIsOpen((prev) => !prev);
        }
    }, [disabled]);
    const onOutsideClick = (0,react.useCallback)(() => setIsOpen(false), []);
    useOnClickOutside(dropdownRef, onOutsideClick);
    const handleSelect = (0,react.useCallback)((item) => {
        setCurrentSelected(item);
        setIsOpen(false);
        onChange === null || onChange === void 0 ? void 0 : onChange(item);
        validate === null || validate === void 0 ? void 0 : validate(item);
    }, [onChange, validate]);
    (0,react.useEffect)(() => {
        setCurrentSelected(selected !== null && selected !== void 0 ? selected : items[0]);
    }, [items, selected]);
    const handleKeyPress = (0,react.useCallback)((event) => {
        const { key } = event;
        if (!isOpen || !optionsRef.current || !LETTER_REGEXP.test(key)) {
            return;
        }
        const lowerKey = key.toLowerCase();
        const matchingIndex = items.findIndex(({ label }) => label.toLowerCase().startsWith(lowerKey));
        if (matchingIndex !== -1) {
            const matchingElement = optionsRef.current.children[matchingIndex];
            matchingElement === null || matchingElement === void 0 ? void 0 : matchingElement.scrollIntoView({ block: 'nearest' });
        }
    }, [items, isOpen]);
    (0,react.useEffect)(() => {
        window.addEventListener('keydown', handleKeyPress);
        return () => {
            window.removeEventListener('keydown', handleKeyPress);
        };
    }, [handleKeyPress]);
    return (react.createElement(FormInput_styles_esm_Container, { ref: dropdownRef, disabled: disabled, error: isError },
        react.createElement(Select, { onClick: toggleDropdown }, currentSelected.label),
        react.createElement(Options, { ref: optionsRef, isOpen: isOpen }, items.map((item, index) => (react.createElement(Option, { key: index, onClick: () => handleSelect(item) }, item.label)))),
        react.createElement(Caret, null)));
};



;// CONCATENATED MODULE: ../../../packages/hermes-booking-calendar/lib/components/FormInput/TextInput.esm.js



const TextInput = ({ defaultValue, placeholder, autocomplete, validate, onInput, }) => {
    const [value, setValue] = (0,react.useState)(defaultValue !== null && defaultValue !== void 0 ? defaultValue : '');
    const handleUpdate = (0,react.useCallback)((e) => {
        var _a, _b;
        const input = (_b = (_a = e.target) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '';
        setValue(input);
        onInput === null || onInput === void 0 ? void 0 : onInput(input);
    }, [onInput]);
    const handleBlur = (0,react.useCallback)(() => {
        validate === null || validate === void 0 ? void 0 : validate(value);
    }, [validate, value]);
    return (react.createElement(FormInput_styles_esm_Container, null,
        react.createElement(Input, { placeholder: placeholder, value: value, onChange: handleUpdate, onBlur: handleBlur, autoComplete: autocomplete })));
};



;// CONCATENATED MODULE: ../../../packages/hermes-booking-calendar/lib/components/FormInput/DOBInput.esm.js





const dayItems = [
    { label: 'Day', value: null },
    ...new Array(31)
        .fill(null)
        .map((_, index) => String(index + 1))
        .map((number) => ({ label: number, value: number })),
];
const monthItems = [
    { label: 'Month', value: null },
    { label: 'January', value: '0' },
    { label: 'February', value: '1' },
    { label: 'March', value: '2' },
    { label: 'April', value: '3' },
    { label: 'May', value: '4' },
    { label: 'June', value: '5' },
    { label: 'July', value: '6' },
    { label: 'August', value: '7' },
    { label: 'September', value: '8' },
    { label: 'October', value: '9' },
    { label: 'November', value: '10' },
    { label: 'December', value: '11' },
];
const currentYear = new Date().getFullYear();
const startYear = currentYear - 18;
const yearItems = [
    { label: 'Year', value: null },
    ...Array.from({ length: 100 }, (_, index) => {
        const year = startYear - index;
        return { label: String(year), value: String(year) };
    }),
];
const DEFAULT_DATE_STATE = {
    day: null,
    month: null,
    year: null,
};
const DOBInput = ({ onChange, validate, disabled, initialValue, }) => {
    const parseDate = (date) => {
        const [year, month, day] = date.split('-').map(Number);
        return { year: String(year), month: String(month - 1), day: String(day) };
    };
    const containerRef = (0,react.useRef)(null);
    const [selectedDate, setSelectedDate] = (0,react.useState)(initialValue ? parseDate(initialValue) : DEFAULT_DATE_STATE);
    const dayItemsNormalized = (0,react.useMemo)(() => {
        if (selectedDate.month && selectedDate.year) {
            const maxDayNumber = new Date(+selectedDate.year, +selectedDate.month + 1, 0).getDate();
            return dayItems.filter((f) => f.value === null || +f.value <= maxDayNumber);
        }
        return dayItems;
    }, [selectedDate.month, selectedDate.year]);
    const selectedDay = (0,react.useMemo)(() => dayItems.find((f) => f.value === selectedDate.day), [selectedDate.day]);
    const selectedMonth = (0,react.useMemo)(() => monthItems.find((f) => f.value === selectedDate.month), [selectedDate.month]);
    const selectedYear = (0,react.useMemo)(() => yearItems.find((f) => f.value === selectedDate.year), [selectedDate.year]);
    const handleDayChange = (0,react.useCallback)((item) => {
        setSelectedDate((prev) => (Object.assign(Object.assign({}, prev), { day: item.value })));
    }, []);
    const handleMonthChange = (0,react.useCallback)((item) => {
        setSelectedDate((prev) => (Object.assign(Object.assign({}, prev), { month: item.value })));
    }, []);
    const handleYearChange = (0,react.useCallback)((item) => {
        setSelectedDate((prev) => (Object.assign(Object.assign({}, prev), { year: item.value })));
    }, []);
    (0,react.useEffect)(() => {
        if (selectedDate.day && selectedDate.month && selectedDate.year) {
            const date = new Date(+selectedDate.year, +selectedDate.month, +selectedDate.day);
            if (date.getDate() !== +selectedDate.day) {
                onChange === null || onChange === void 0 ? void 0 : onChange(null);
                setSelectedDate((prev) => (Object.assign(Object.assign({}, prev), { day: DEFAULT_DATE_STATE.day })));
                validate === null || validate === void 0 ? void 0 : validate(null);
                return;
            }
            onChange === null || onChange === void 0 ? void 0 : onChange(formatDateWithoutTimezone(date));
        }
    }, [
        selectedDate.day,
        selectedDate.month,
        selectedDate.year,
        onChange,
        validate,
    ]);
    return (react.createElement(DOBContainer, { ref: containerRef },
        react.createElement("div", { style: { width: '100%', maxWidth: '96px' } },
            react.createElement(Dropdown, { disabled: disabled, selected: selectedDay, items: dayItemsNormalized, onChange: handleDayChange })),
        react.createElement(Dropdown, { disabled: disabled, selected: selectedMonth, items: monthItems, onChange: handleMonthChange }),
        react.createElement("div", { style: { width: '100%', maxWidth: '96px' } },
            react.createElement(Dropdown, { disabled: disabled, selected: selectedYear, items: yearItems, onChange: handleYearChange }))));
};



// EXTERNAL MODULE: ../../../packages/hermes-booking-calendar/lib/node_modules/react-phone-number-input/min/index.esm.js + 82 modules
var min_index_esm = __webpack_require__(37716);
;// CONCATENATED MODULE: ../../../packages/hermes-booking-calendar/lib/components/FormInput/PhoneInput.esm.js




const defaultCountryMeta = {
    countryCode: '+44',
    countryShortName: 'GB',
};
const PhoneInput = ({ initialPhoneNumber, placeholder, required, validate, onInput, }) => {
    const [phoneNumber, setPhoneNumber] = (0,react.useState)(initialPhoneNumber || '');
    const handleInput = (0,react.useCallback)((value) => {
        const input = value !== null && value !== void 0 ? value : '';
        setPhoneNumber(input);
        onInput === null || onInput === void 0 ? void 0 : onInput(input);
    }, [onInput]);
    const handleBlur = (0,react.useCallback)(() => {
        validate === null || validate === void 0 ? void 0 : validate(required && !phoneNumber ? '' : phoneNumber);
    }, [phoneNumber, required, validate]);
    return (react.createElement(PhoneInputContainer, null,
        react.createElement(min_index_esm/* default */.Z, { international: true, countryCallingCodeEditable: false, addInternationalOption: false, onBlur: handleBlur, placeholder: placeholder, value: phoneNumber, onChange: handleInput, defaultCountry: defaultCountryMeta.countryShortName })));
};



;// CONCATENATED MODULE: ../../../packages/hermes-booking-calendar/lib/components/FilterToggle/styles.esm.js


const PseudoBackground = (0,styled_esm/* default */.ZP)('div')(({ theme }) => ({
    backgroundColor: theme.palette.background.default,
    borderRadius: '20px',
    height: '100%',
    position: 'absolute',
    top: 0,
    transition: 'left 0.3s ease-in-out',
    width: '100%',
    zIndex: 0,
    transform: 'scale(99%, 90%)',
}));
const FilterToggleWrapper = (0,styled_esm/* default */.ZP)('div')(({ theme }) => ({
    alignItems: 'center',
    backgroundColor: theme.palette.grey[600],
    borderRadius: '27px',
    display: 'flex',
    overflow: 'hidden',
    position: 'relative',
    width: '100%',
    '&:hover': {
        backgroundColor: theme.palette.blue[600],
    },
    p: {
        fontFamily: `'Poppins', sans-serif`,
        fontSize: '14px',
        fontStyle: 'normal',
        fontWeight: 500,
        lineHeight: '20px',
        '@media (max-width: 560px)': {
            display: 'none',
        },
    },
}));
const FilterToggleItem = (0,styled_esm/* default */.ZP)('div')(({ theme, active }) => ({
    flexGrow: 1,
    flexShrink: 1,
    flexBasis: 0,
    borderRadius: '20px',
    fontFamily: `'Poppins', sans-serif`,
    fontSize: '14px',
    fontWeight: active ? 500 : 400,
    color: active ? theme.palette.primary.main : theme.palette.system.navy900,
    cursor: 'pointer',
    padding: '10px 0',
    textAlign: 'center',
    userSelect: 'none',
    zIndex: 1,
}));



;// CONCATENATED MODULE: ../../../packages/hermes-booking-calendar/lib/components/FilterToggle/index.esm.js



const FilterToggle = ({ onChange, items, value }) => {
    const [activeIndex, setActiveIndex] = (0,react.useState)(items.findIndex((item) => item.value === value));
    const [dimensions, setDimensions] = (0,react.useState)({ width: 0, left: 0 });
    const itemRefs = (0,react.useRef)([]);
    const wrapperRef = (0,react.useRef)(null);
    const handleChangeActiveToggle = (0,react.useCallback)((item, index) => {
        setActiveIndex(index);
        onChange === null || onChange === void 0 ? void 0 : onChange(item);
    }, [onChange]);
    (0,react.useEffect)(() => {
        setActiveIndex(items.findIndex((item) => item.value === value));
    }, [value, items]);
    (0,react.useLayoutEffect)(() => {
        var _a;
        const activeItemWidth = ((_a = itemRefs.current[activeIndex]) === null || _a === void 0 ? void 0 : _a.offsetWidth) || 0;
        const leftOffset = itemRefs.current
            .slice(0, activeIndex)
            .reduce((acc, ref) => acc + ((ref === null || ref === void 0 ? void 0 : ref.offsetWidth) || 0), 0);
        setDimensions({ width: activeItemWidth, left: leftOffset });
    }, [activeIndex, items]);
    return (react.createElement(FilterToggleWrapper, { ref: wrapperRef },
        react.createElement(PseudoBackground, { style: {
                left: `${dimensions.left}px`,
                width: `${dimensions.width}px`,
                transition: 'left 0.3s ease, width 0.3s ease',
            } }),
        items.map((item, index) => (react.createElement(FilterToggleItem, { key: item.value, active: activeIndex === index, onClick: (0,react.useCallback)(() => handleChangeActiveToggle(item, index), []), ref: (el) => {
                itemRefs.current[index] = el;
            } }, item.label)))));
};



// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Hidden/Hidden.esm.js + 4 modules
var Hidden_esm = __webpack_require__(49889);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/CircularProgress/CircularProgress.esm.js + 1 modules
var CircularProgress_esm = __webpack_require__(28310);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/components/GoogleRecaptchaLogo/index.esm.js + 2 modules
var GoogleRecaptchaLogo_index_esm = __webpack_require__(61623);
;// CONCATENATED MODULE: ../../../packages/hermes-booking-calendar/lib/components/InsuranceDropdown/index.esm.js




const InsuranceDropdown = ({ onClick, selected, validate, disabled, isError, }) => {
    const [firstRender, setFirstRender] = (0,react.useState)(true);
    const [selectedItem] = (0,react.useState)(selected);
    (0,react.useEffect)(() => {
        if (selected) {
            if (firstRender && (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.value) === (selected === null || selected === void 0 ? void 0 : selected.value)) {
                return;
            }
            else {
                setFirstRender(false);
                validate === null || validate === void 0 ? void 0 : validate(selected);
            }
        }
    }, [selected, firstRender]);
    return (react.createElement(FormInput_styles_esm_Container, { disabled: disabled, error: isError },
        react.createElement(Select, { onClick: onClick }, selected === null || selected === void 0 ? void 0 : selected.label),
        react.createElement(Caret, null)));
};



;// CONCATENATED MODULE: ../../../packages/hermes-booking-calendar/lib/screens/BookingForm/styles.esm.js


const BookingForm_styles_esm_Container = (0,styled_esm/* default */.ZP)('div')({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'flex-start',
    width: '100%',
    gap: '70px',
    flexWrap: 'wrap',
});
const FormSection = (0,styled_esm/* default */.ZP)('div')({
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
    maxWidth: '512px',
    flex: '0 0 80%',
});
const ProfileInfoSection = (0,styled_esm/* default */.ZP)('div')(({ theme }) => ({
    flex: '0 0 20%',
    width: '100%',
    minWidth: '417px',
    maxWidth: '512px',
    display: 'flex',
    flexDirection: 'column',
    border: `solid thin ${theme.palette.grey[600]}`,
    borderRadius: '16px',
    padding: '20px',
    '&>hr': {
        margin: '24px 0',
        width: '100%',
        border: 'none',
        borderTop: `solid thin ${theme.palette.grey[600]}`,
    },
    '&>span': {
        color: theme.palette.system.navy900,
        fontFamily: `'Poppins', sans-serif`,
        fontSize: '13px',
        fontStyle: 'normal',
        fontWeight: 400,
        lineHeight: '20px',
    },
}));
const ProfileInfo = (0,styled_esm/* default */.ZP)('div')({
    display: 'flex',
    gap: '16px',
    '&>img': {
        borderRadius: '8px',
        width: '82px',
        height: '82px',
    },
});
const ProfileMetrics = (0,styled_esm/* default */.ZP)('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '8px',
    color: theme.palette.system.navy900,
    fontFamily: `'Poppins', sans-serif`,
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '20px',
    '&>h5': {
        color: theme.palette.system.navy900,
        textAlign: 'center',
        fontFamily: `'Poppins', sans-serif`,
        fontSize: '18px',
        fontStyle: 'normal',
        fontWeight: 600,
        lineHeight: '26px',
        margin: 0,
    },
    '&>h6': {
        color: theme.palette.system.navy900,
        fontFamily: `'Poppins', sans-serif`,
        fontSize: '14px',
        fontStyle: 'normal',
        fontWeight: 600,
        lineHeight: '20px',
        margin: 0,
    },
}));
const ReviewsInfo = (0,styled_esm/* default */.ZP)('div')(({ theme }) => ({
    display: 'flex',
    gap: '8px',
    '&>span': {
        color: theme.palette.system.navy900,
        fontFamily: `'Poppins', sans-serif`,
        fontSize: '14px',
        fontStyle: 'normal',
        fontWeight: 400,
        lineHeight: '20px',
    },
}));
const styles_esm_BookingInfo = (0,styled_esm/* default */.ZP)('div')(({ theme }) => ({
    display: 'flex',
    gap: '8px',
    '&>span': {
        color: theme.palette.system.navy900,
        fontFamily: `'Poppins', sans-serif`,
        fontSize: '14px',
        fontStyle: 'normal',
        fontWeight: 500,
        lineHeight: '20px',
    },
}));
const HeaderWrapper = (0,styled_esm/* default */.ZP)('div')({
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
});
const Header = (0,styled_esm/* default */.ZP)('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    '&>h5': {
        color: theme.palette.text.darkNavy,
        fontFamily: `'Klarheit Kurrent', sans-serif`,
        fontSize: '21.36px',
        fontStyle: 'normal',
        fontWeight: 700,
        lineHeight: '25px',
        margin: 0,
    },
    '&>span': {
        color: theme.palette.text.black700,
        fontFamily: `'Poppins', sans-serif`,
        fontSize: '16px',
        fontStyle: 'normal',
        fontWeight: 400,
        lineHeight: '24px',
    },
}));
const BottomSection = (0,styled_esm/* default */.ZP)('div')({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '16px',
});
const CommonText = (0,styled_esm/* default */.ZP)('span')(({ theme }) => ({
    color: theme.palette.text.secondary,
    textAlign: 'center',
    fontFamily: `'Poppins', sans-serif`,
    fontSize: '13px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '20px',
}));



// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/FormControlLabel/FormControlLabel.esm.js + 1 modules
var FormControlLabel_esm = __webpack_require__(13837);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Checkbox/Checkbox.esm.js + 4 modules
var Checkbox_esm = __webpack_require__(76898);
;// CONCATENATED MODULE: ../../../packages/hermes-booking-calendar/lib/components/Checkbox/index.esm.js



const Checkbox = ({ defaultValue, isError, label, onChange, }) => {
    const [checked, setChecked] = (0,react.useState)(defaultValue !== null && defaultValue !== void 0 ? defaultValue : false);
    const handleChange = (0,react.useCallback)((e) => {
        var _a, _b;
        const value = (_b = (_a = e.target) === null || _a === void 0 ? void 0 : _a.checked) !== null && _b !== void 0 ? _b : false;
        setChecked(value);
        onChange === null || onChange === void 0 ? void 0 : onChange(value);
    }, []);
    return (react.createElement(FormControlLabel_esm/* default */.Z, { sx: { alignItems: 'flex-start' }, control: react.createElement(Checkbox_esm/* default */.Z, { sx: {
                paddingTop: '1px',
                '& .MuiSvgIcon-root': {
                    fontSize: 22,
                    color: isError ? '#CC4F4A' : 'inherit',
                },
            }, checked: checked, onChange: handleChange }), label: label }));
};



// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/RadioGroup/RadioGroup.esm.js + 2 modules
var RadioGroup_esm = __webpack_require__(93666);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Radio/Radio.esm.js + 5 modules
var Radio_esm = __webpack_require__(78402);
;// CONCATENATED MODULE: ../../../packages/hermes-booking-calendar/lib/components/Radio/index.esm.js



const Radio = ({ defaultValue, options = [], label, onChange }) => {
    const handleChange = (0,react.useCallback)((_, value) => {
        onChange === null || onChange === void 0 ? void 0 : onChange(value);
    }, []);
    return (react.createElement(FormControlLabel_esm/* default */.Z, { sx: { alignItems: 'flex-start', paddingLeft: '12px' }, control: react.createElement(RadioGroup_esm/* default */.Z, { "aria-labelledby": `${label}-radio-group`, defaultValue: defaultValue, name: `${label}-radio-group`, onChange: handleChange }, options.map((option) => (react.createElement(FormControlLabel_esm/* default */.Z, { value: option.value, control: react.createElement(Radio_esm/* default */.Z, { sx: {
                    '&.Mui-checked': {
                        color: '#1A3586',
                    },
                } }), label: option.label })))), label: label }));
};



;// CONCATENATED MODULE: ../../../packages/hermes-booking-calendar/lib/hooks/useFormData.esm.js


const useFormData = (formOptions) => {
    const [errorMessages, setErrorMessages] = (0,react.useState)(Object.assign({}, Object.keys(formOptions).reduce((p, key) => (Object.assign(Object.assign({}, p), { [key]: '' })), {})));
    const formSchema = (0,react.useMemo)(() => (Object.assign({}, Object.keys(formOptions).reduce((p, key) => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        return (Object.assign(Object.assign({}, p), { [key]: {
                required: (_a = formOptions[key]) === null || _a === void 0 ? void 0 : _a.required,
                type: (_b = formOptions[key]) === null || _b === void 0 ? void 0 : _b.type,
                label: (_c = formOptions[key]) === null || _c === void 0 ? void 0 : _c.label,
                items: (_d = formOptions[key]) === null || _d === void 0 ? void 0 : _d.items,
                placeholder: (_e = formOptions[key]) === null || _e === void 0 ? void 0 : _e.placeholder,
                autocomplete: (_f = formOptions[key]) === null || _f === void 0 ? void 0 : _f.autocomplete,
                onChange: (_g = formOptions[key]) === null || _g === void 0 ? void 0 : _g.onChange,
                onClick: (_h = formOptions[key]) === null || _h === void 0 ? void 0 : _h.onClick,
                hint: (_j = formOptions[key]) === null || _j === void 0 ? void 0 : _j.hint,
                disclaimer: (_k = formOptions[key]) === null || _k === void 0 ? void 0 : _k.disclaimer,
                validate: (input) => setErrorMessages((prevState) => {
                    var _a, _b, _c;
                    return (Object.assign(Object.assign({}, prevState), { [key]: (_c = (_b = (_a = formOptions[key]) === null || _a === void 0 ? void 0 : _a.validateFn) === null || _b === void 0 ? void 0 : _b.call(_a, input)) !== null && _c !== void 0 ? _c : '' }));
                }),
            } }));
    }, {}))), [formOptions]);
    const closeErrorMessage = (0,react.useCallback)((key) => setErrorMessages((prevState) => (Object.assign(Object.assign({}, prevState), { [key]: '' }))), []);
    return (0,react.useMemo)(() => [formSchema, errorMessages, closeErrorMessage], [formSchema, errorMessages, closeErrorMessage]);
};



// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/styles/useTheme.esm.js
var useTheme_esm = __webpack_require__(36713);
;// CONCATENATED MODULE: ../../../packages/hermes-booking-calendar/lib/utils/resolveThemeComponent.esm.js


const resolveThemeComponent = (components) => {
    const theme = (0,useTheme_esm/* default */.Z)();
    const themeName = theme.name;
    return components[themeName];
};



;// CONCATENATED MODULE: ../../../packages/hermes-booking-calendar/lib/icons/Chevron.esm.js


const getChevronDirection = (direction) => {
    if (direction === 'right')
        return '180';
    if (direction === 'up')
        return '90';
    if (direction === 'down')
        return '-90';
    return '0';
};
const Chevron = ({ direction = 'left' }) => (react.createElement("svg", { width: "9", height: "14", viewBox: "0 0 9 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", style: {
        transform: `rotate(${getChevronDirection(direction)}deg)`,
    } },
    react.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.28906 12.2869C8.28906 11.9722 8.14374 11.6915 7.91655 11.5082L3.41821 7.00003L7.99821 2.41003L7.99227 2.4041C8.17553 2.22283 8.28906 1.97123 8.28906 1.69311C8.28906 1.14083 7.84135 0.693114 7.28906 0.693114C6.95183 0.693114 6.65358 0.860048 6.47245 1.11579L0.588208 7.00003L6.5703 12.9821C6.75211 13.17 7.00694 13.2869 7.28906 13.2869C7.84135 13.2869 8.28906 12.8391 8.28906 12.2869Z", fill: "currentColor" })));



;// CONCATENATED MODULE: ../../../packages/hermes-booking-calendar/lib/components/Button/PreviousButton.esm.js






const PreviousButton = (_a) => {
    var { sx } = _a, props = __rest(_a, ["sx"]);
    return (react.createElement(Button_esm/* default */.Z, Object.assign({ sx: Object.assign({ minWidth: 'auto', width: '40px', height: '40px', padding: 0, backgroundColor: 'background.light' }, sx) }, props),
        react.createElement(Chevron, null)));
};



;// CONCATENATED MODULE: ../../../packages/hermes-booking-calendar/lib/hooks/useWpaTenant.esm.js



const useWpaTenant = () => {
    const theme = (0,useTheme_esm/* default */.Z)();
    const isWPA = (0,react.useMemo)(() => theme.name === 'wpa', [theme]);
    return { isWPA };
};



;// CONCATENATED MODULE: ../../../packages/hermes-booking-calendar/lib/screens/BookingForm/index.esm.js


























const DISABLED_AUTO_SAVE_KEYS = ['agreement'];
const emailRegex = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;
const CACHED_FORM_DATA_KEY_PREFIX = 'REQUEST_BOOKING_FORM_DATA';
const DEFAULT_FORM_STATE = {
    visitType: 'new',
    visitReason: '',
    firstName: '',
    lastName: '',
    email: '',
    phoneNumber: '',
    dob: '',
    paymentMethod: 'self',
    bookingFor: '',
    title: '',
    agreement: false,
    gender: '',
    addressLine: '',
    addressLine1: '',
    addressLine2: '',
    city: '',
    postalCode: '',
    claimNumber: '',
    policyNumber: '',
    employeeId: '',
};
const BookingForm = ({ onFormSubmit, onBackButtonClick, visitTypeOptions, visitReasonOptions, bookForOptions, bookingInfo, selectedInsurance, onInsuranceSelectClick, formFields = Object.keys(DEFAULT_FORM_STATE), genderOptions, source, titleOptions, insuranceOptions, insuranceSelectMethod, }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const { isWPA } = useWpaTenant();
    const CACHED_FORM_DATA_KEY = `${CACHED_FORM_DATA_KEY_PREFIX}_${bookingInfo.specialistProfile.id}`;
    const getInitialFormData = () => {
        const cachedData = localStorage.getItem(CACHED_FORM_DATA_KEY);
        return cachedData ? JSON.parse(cachedData) : DEFAULT_FORM_STATE;
    };
    const [formData, setFormData] = (0,react.useState)(getInitialFormData());
    const [isSubmitting, setIsSubmitting] = (0,react.useState)(false);
    const [bookingForDisclaimer, setBookingForDisclaimer] = (0,react.useState)('');
    const updateFormData = (0,react.useCallback)((key, value) => {
        setFormData((prevData) => {
            const newData = Object.assign(Object.assign({}, prevData), { [key]: value });
            if (!DISABLED_AUTO_SAVE_KEYS.includes(key)) {
                const dataToSave = Object.assign({}, newData);
                DISABLED_AUTO_SAVE_KEYS.forEach((excludedKey) => delete dataToSave[excludedKey]);
                localStorage.setItem(CACHED_FORM_DATA_KEY, JSON.stringify(dataToSave));
            }
            return newData;
        });
    }, []);
    const [formSchema, errorMessages, closeErrorMessage] = useFormData((0,react.useMemo)(() => {
        var _a;
        const finalSchema = {};
        const schema = {
            visitType: {
                required: true,
                type: 'invisible',
                items: visitTypeOptions,
                onChange: (item) => updateFormData('visitType', item.value),
            },
            visitReason: {
                required: false,
                type: 'dropdown',
                label: 'Reason for visit',
                items: visitReasonOptions,
                onChange: (item) => updateFormData('visitReason', item.value),
            },
            firstName: {
                required: true,
                type: 'text',
                label: 'First name',
                placeholder: 'Add first name',
                validateFn: (input) => input ? '' : 'Please enter this field',
                onChange: (value) => updateFormData('firstName', value),
            },
            lastName: {
                required: true,
                type: 'text',
                label: 'Last name',
                placeholder: 'Add last name',
                validateFn: (input) => input ? '' : 'Please enter this field',
                onChange: (value) => updateFormData('lastName', value),
            },
            email: {
                required: true,
                type: 'text',
                label: 'Email',
                placeholder: 'Add email address',
                validateFn: (input) => {
                    if (!input) {
                        return 'Please enter this field';
                    }
                    if (!emailRegex.test(input)) {
                        return 'Invalid email address';
                    }
                    return '';
                },
                onChange: (value) => updateFormData('email', value),
            },
            addressLine: {
                required: true,
                type: 'text',
                label: 'Address',
                placeholder: 'Add address',
                validateFn: (input) => input ? '' : 'Please enter this field',
                onChange: (value) => updateFormData('addressLine', value),
            },
            addressLine1: {
                required: true,
                type: 'text',
                label: 'Address line 1',
                placeholder: 'Add street address',
                autocomplete: 'address-line1',
                validateFn: (input) => input ? '' : 'Please enter this field',
                onChange: (value) => updateFormData('addressLine1', value),
            },
            addressLine2: {
                required: false,
                type: 'text',
                label: 'Address line 2',
                placeholder: 'Add address info (optional)',
                autocomplete: 'address-line2',
                onChange: (value) => updateFormData('addressLine2', value),
            },
            city: {
                required: true,
                type: 'text',
                label: 'Town / City',
                placeholder: 'Eg London',
                autocomplete: 'address-level2',
                validateFn: (input) => input ? '' : 'Please enter this field',
                onChange: (value) => updateFormData('city', value),
            },
            postalCode: {
                required: true,
                type: 'text',
                label: 'Post code',
                placeholder: 'Add post code',
                autocomplete: 'postal-code',
                validateFn: (input) => input ? '' : 'Please enter this field',
                onChange: (value) => updateFormData('postalCode', value),
            },
            claimNumber: {
                required: true,
                type: 'text',
                label: 'Claim reference',
                placeholder: 'E.g. ABCDEF',
                hint: 'This is used to match your claim to your appointment',
                validateFn: (input) => {
                    if (!input || !/^[A-Za-z]{6}$/.test(input)) {
                        return 'Your WPA claim reference is a 6 letter code';
                    }
                    return '';
                },
                onChange: (value) => updateFormData('claimNumber', value),
            },
            policyNumber: {
                required: true,
                type: 'text',
                label: 'Customer number',
                placeholder: 'E.g. 123456789',
                hint: 'This is used to identify your policy',
                validateFn: (input) => {
                    if (isWPA) {
                        if (!input || !/^[0-9]{1,9}$/.test(input)) {
                            return 'Your WPA customer number is a numerical code up to 9 numbers';
                        }
                        return '';
                    }
                    if (!input) {
                        return 'Customer number is missing';
                    }
                    return '';
                },
                onChange: (value) => updateFormData('policyNumber', value),
            },
            employeeId: {
                required: false,
                type: 'text',
                label: 'Agent ID (for internal purposes only)',
                placeholder: 'E.g. ABC',
                hint: 'This optional field should only be filled in by WPA agents',
                validateFn: (input) => {
                    if ((input === null || input === void 0 ? void 0 : input.length) && !/^[A-Za-z]{3}$/.test(input)) {
                        return 'Agent ID is a 3 letter reference';
                    }
                    return '';
                },
                onChange: (value) => updateFormData('employeeId', value),
            },
            phoneNumber: {
                required: true,
                type: 'phone',
                label: 'Phone',
                placeholder: 'Add phone number',
                validateFn: (phoneNumber) => {
                    return (0,min_index_esm/* isValidPhoneNumber */.y)(phoneNumber)
                        ? ''
                        : 'Invalid phone number';
                },
                onChange: (value) => updateFormData('phoneNumber', value),
            },
            dob: {
                required: true,
                type: 'dob',
                label: 'Date of birth',
                hint: isWPA
                    ? ''
                    : 'If the patient is under 18 years old, please call or email us to arrange an appointment.',
                validateFn: (date) => {
                    if (!date) {
                        return 'Invalid input';
                    }
                    const today = new Date();
                    const birthdate = new Date(date);
                    const eighteenYearsAgo = new Date(today.getFullYear() - 18, today.getMonth(), today.getDate());
                    if (birthdate > eighteenYearsAgo) {
                        return 'Must be at least 18 years old to proceed';
                    }
                    return '';
                },
                onChange: (value) => updateFormData('dob', value),
            },
            gender: {
                required: true,
                type: 'dropdown',
                items: genderOptions,
                label: 'Gender',
                validateFn: (item) => (item ? '' : 'Invalid input'),
                onChange: (item) => updateFormData('gender', item.value),
            },
            paymentMethod: insuranceSelectMethod === 'dropdown'
                ? {
                    required: true,
                    type: 'insuranceDropdown',
                    label: 'Select payment method',
                    items: (_a = insuranceOptions === null || insuranceOptions === void 0 ? void 0 : insuranceOptions.filter((f) => !f.label.toLowerCase().includes('self-pay'))) !== null && _a !== void 0 ? _a : [],
                    validateFn: (item) => (item ? '' : 'This input is required'),
                    onChange: (item) => updateFormData('paymentMethod', item.value),
                }
                : {
                    required: true,
                    type: 'insuranceOutside',
                    label: 'Select payment method',
                    validateFn: () => (selectedInsurance === null || selectedInsurance === void 0 ? void 0 : selectedInsurance.value) ? '' : 'This input is required',
                    onClick: onInsuranceSelectClick,
                },
            bookingFor: {
                required: true,
                type: 'dropdown',
                label: 'Who are you booking for?',
                items: bookForOptions,
                validateFn: (value) => value ? '' : 'This input is required',
                disclaimer: bookingForDisclaimer,
                onChange: (item) => {
                    setBookingForDisclaimer(item.value === 'someone-else'
                        ? "Please enter the patient's details below"
                        : '');
                    updateFormData('bookingFor', item.value);
                },
            },
            title: {
                required: true,
                type: 'dropdown',
                label: 'Title',
                items: titleOptions,
                validateFn: (value) => value ? '' : 'This input is required',
                onChange: (item) => updateFormData('title', item.value),
            },
            agreement: {
                required: true,
                type: 'checkbox',
                label: (react.createElement("span", null,
                    "I confirm I am over 18 years old and agree to the",
                    ' ',
                    react.createElement("a", { href: 'https://www.doctify.com/uk/about/privacy-policy', target: '_blank' }, "Privacy Policy"),
                    ' ',
                    "and",
                    ' ',
                    react.createElement("a", { href: 'https://www.doctify.com/uk/about/terms-and-conditions', target: '_blank' }, "Terms & Conditions"))),
                validateFn: (value) => value ? '' : 'This input is required',
                onChange: (value) => updateFormData('agreement', value),
            },
        };
        formFields.forEach((key) => {
            const formFieldKey = key;
            finalSchema[formFieldKey] = schema[formFieldKey];
        });
        return finalSchema;
    }, [
        selectedInsurance,
        visitTypeOptions,
        visitReasonOptions,
        bookForOptions,
        onInsuranceSelectClick,
        formFields,
        isWPA,
        bookingForDisclaimer,
        insuranceSelectMethod,
        insuranceOptions,
    ]));
    const onSubmit = (0,react.useCallback)(() => {
        var _a, _b, _c;
        setIsSubmitting(true);
        const filteredFormData = Object.keys(formData).reduce((data, key) => formFields.includes(key)
            ? Object.assign(Object.assign({}, data), { [key]: formData[key] }) : data, {});
        Object.keys(formSchema).forEach((key) => {
            var _a, _b;
            const formFieldKey = key;
            (_b = (_a = formSchema === null || formSchema === void 0 ? void 0 : formSchema[formFieldKey]) === null || _a === void 0 ? void 0 : _a.validate) === null || _b === void 0 ? void 0 : _b.call(_a, filteredFormData === null || filteredFormData === void 0 ? void 0 : filteredFormData[formFieldKey]);
        });
        const insurerId = filteredFormData.paymentMethod === 'self'
            ? +((_b = (_a = insuranceOptions === null || insuranceOptions === void 0 ? void 0 : insuranceOptions.find((io) => io.label.toLowerCase().includes('self-pay'))) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '')
            : +filteredFormData.paymentMethod;
        const finalFormData = Object.assign(Object.assign({}, filteredFormData), { provider: bookingInfo.provider, availabilityId: bookingInfo.availabilityId, prefix: (_c = genderOptions.find((option) => option.value === filteredFormData.gender)) === null || _c === void 0 ? void 0 : _c.prefix, source,
            insurerId, addressLine: filteredFormData.addressLine1 || filteredFormData.addressLine, practiceId: bookingInfo.practiceProfile.id });
        setTimeout(() => {
            const errorItems = document.querySelectorAll('.form-input-error');
            const errors = Array.from(errorItems);
            const isFormValid = !errors.length;
            if (isFormValid) {
                onFormSubmit(finalFormData)
                    .then((isSuccessful) => {
                    if (isSuccessful) {
                        localStorage.removeItem(CACHED_FORM_DATA_KEY);
                    }
                })
                    .finally(() => {
                    setIsSubmitting(false);
                });
            }
            else {
                setIsSubmitting(false);
            }
        }, 200);
    }, [formSchema, formData, insuranceOptions]);
    const containerRef = (0,react.useRef)(null);
    const bookingInfoBigRef = (0,react.useRef)(null);
    const bookingInfoSmallRef = (0,react.useRef)(null);
    (0,react.useEffect)(() => {
        const swapElements = () => {
            if (containerRef.current &&
                bookingInfoBigRef.current &&
                bookingInfoSmallRef) {
                const container = containerRef.current;
                const bookingInfoBig = bookingInfoBigRef.current;
                const bookingInfoSmall = bookingInfoSmallRef.current;
                if (container.getBoundingClientRect().width < 1040) {
                    bookingInfoBig.style.display = 'none';
                    bookingInfoSmall.style.display = 'flex';
                }
                else {
                    bookingInfoBig.style.display = 'flex';
                    bookingInfoSmall.style.display = 'none';
                }
            }
        };
        window.addEventListener('resize', swapElements);
        swapElements();
        return () => {
            window.removeEventListener('resize', swapElements);
        };
    }, [containerRef, bookingInfoBigRef, bookingInfoSmallRef]);
    const getInputComponent = (0,react.useCallback)((formSchemaItem, formFieldKey) => {
        var _a, _b;
        if (formSchemaItem.type === 'dropdown') {
            return (react.createElement(Dropdown, { selected: (_a = formSchemaItem.items) === null || _a === void 0 ? void 0 : _a.find((item) => item.value === formData[formFieldKey]), items: formSchemaItem.items, onChange: formSchemaItem.onChange }));
        }
        if (formSchemaItem.type === 'text') {
            return (react.createElement(TextInput, { defaultValue: formData[formFieldKey], placeholder: formSchemaItem.placeholder, validate: formSchemaItem.validate, onInput: formSchemaItem.onChange, autocomplete: formSchemaItem.autocomplete }));
        }
        if (formSchemaItem.type === 'phone') {
            return (react.createElement(PhoneInput, { initialPhoneNumber: formData[formFieldKey], placeholder: formSchemaItem.placeholder, validate: formSchemaItem.validate, onInput: formSchemaItem.onChange }));
        }
        if (formSchemaItem.type === 'dob') {
            return (react.createElement(DOBInput, { initialValue: formData[formFieldKey], onChange: formSchemaItem.onChange, validate: formSchemaItem.validate }));
        }
        if (formSchemaItem.type === 'insuranceDropdown') {
            return (react.createElement(FormSection, null,
                react.createElement(Radio, { onChange: (val) => updateFormData('paymentMethod', val), options: [
                        { label: 'I am paying myself', value: 'self' },
                        { label: 'I have medical insurance', value: '' },
                    ], defaultValue: 'self' }),
                formData.paymentMethod === 'self' ? null : (react.createElement(react.Fragment, null,
                    react.createElement(Dropdown, { selected: (_b = formSchemaItem.items) === null || _b === void 0 ? void 0 : _b.find((item) => item.value === formData[formFieldKey]), items: formSchemaItem.items, onChange: formSchemaItem.onChange }),
                    react.createElement("div", { style: { fontSize: '15px', marginBottom: '30px' } }, "Please note that you'll need to provide your policy/member number and any relevant claim or pre-authorisation details when confirming your booking.")))));
        }
        if (formSchemaItem.type === 'insuranceOutside') {
            return (react.createElement(InsuranceDropdown, { selected: selectedInsurance, validate: formSchemaItem.validate, onClick: formSchemaItem.onClick }));
        }
        if (formSchemaItem.type === 'checkbox') {
            return (react.createElement(Checkbox, { label: formSchemaItem.label, onChange: formSchemaItem.onChange }));
        }
        return react.createElement(react.Fragment, null);
    }, [selectedInsurance, formData.paymentMethod]);
    return (react.createElement(BookingForm_styles_esm_Container, { ref: containerRef },
        react.createElement(FormSection, { style: { paddingBottom: 20 } },
            react.createElement(HeaderWrapper, null,
                react.createElement(Header, null,
                    react.createElement(Title, { style: {
                            position: 'relative',
                        } }, resolveThemeComponent({
                        default: (react.createElement(react.Fragment, null,
                            react.createElement("div", { style: { cursor: 'pointer' }, onClick: onBackButtonClick },
                                react.createElement(ArrowBack, null)),
                            react.createElement("span", null, "Request booking"))),
                        wpa: (react.createElement(Grid_esm/* default */.ZP, { container: true, direction: "column" },
                            react.createElement(PreviousButton, { onClick: onBackButtonClick, sx: {
                                    position: 'absolute',
                                    left: '-80px',
                                    '@media(max-width: 1240px)': {
                                        display: 'none',
                                    },
                                } }),
                            react.createElement("span", null, "Request booking"),
                            react.createElement(Hidden_esm/* default */.Z, { mdDown: true, implementation: "css" },
                                react.createElement(Typography_esm/* default */.Z, { variant: "subtitle1", component: "span", color: "text.black700" },
                                    "Please add your details to request the appointment with",
                                    ' ',
                                    bookingInfo.specialistProfile.title,
                                    ' ',
                                    bookingInfo.specialistProfile.name,
                                    "\u2019s clinic.")))),
                    })),
                    react.createElement(StepFooter_styles_esm_Container, { style: { margin: '8px 0px' }, ref: bookingInfoSmallRef },
                        react.createElement(BookingInfo, { specialistProfile: bookingInfo === null || bookingInfo === void 0 ? void 0 : bookingInfo.specialistProfile, practiceProfile: bookingInfo === null || bookingInfo === void 0 ? void 0 : bookingInfo.practiceProfile, dateString: formatDateStringToDisplay(bookingInfo.dateString), timeString: formatTimeStringToDisplay(bookingInfo.timeString) }))),
                (formSchema === null || formSchema === void 0 ? void 0 : formSchema.visitType) && (react.createElement(FilterToggle, { items: formSchema.visitType.items, value: formData.visitType, onChange: formSchema.visitType.onChange }))),
            Object.keys(formSchema).map((key) => {
                const formFieldKey = key;
                const formSchemaItem = formSchema[formFieldKey];
                if (formSchemaItem.type === 'invisible') {
                    return null;
                }
                return (react.createElement(FormItem, { key: key, formFieldKey: formFieldKey, label: formSchemaItem.type === 'checkbox' ? '' : formSchemaItem.label, errorMessage: errorMessages[formFieldKey], onErrorClose: closeErrorMessage, inputComponent: getInputComponent(formSchemaItem, formFieldKey), required: formSchemaItem.required, hint: formSchemaItem.hint, disclaimer: formSchemaItem.disclaimer }));
            }),
            react.createElement(BottomSection, { style: { marginTop: 12 } },
                react.createElement(Button_esm/* default */.Z, { disabled: isSubmitting, style: isWPA
                        ? {}
                        : {
                            color: '#2B59E0',
                            borderColor: '#2B59E0',
                        }, variant: isWPA ? 'request' : 'secondary', onClick: onSubmit },
                    react.createElement(Typography_esm/* default */.Z, { style: { display: 'initial' }, component: "span" }, "Request booking"),
                    isSubmitting && (react.createElement(CircularProgress_esm/* default */.Z, { size: 20, sx: { color: '#80858D' } }))),
                !isWPA && react.createElement(CommonText, null, "You won\u2019t be charged yet"),
                react.createElement(GoogleRecaptchaLogo_index_esm/* GoogleRecaptchaLogo */.n, null))),
        react.createElement(ProfileInfoSection, { ref: bookingInfoBigRef },
            react.createElement(ProfileInfo, null,
                react.createElement("img", { alt: '', src: (_a = bookingInfo === null || bookingInfo === void 0 ? void 0 : bookingInfo.specialistProfile) === null || _a === void 0 ? void 0 : _a.imageSrc }),
                react.createElement(ProfileMetrics, null,
                    react.createElement("h5", null, (_b = bookingInfo === null || bookingInfo === void 0 ? void 0 : bookingInfo.specialistProfile) === null || _b === void 0 ? void 0 :
                        _b.title,
                        ' ', (_c = bookingInfo === null || bookingInfo === void 0 ? void 0 : bookingInfo.specialistProfile) === null || _c === void 0 ? void 0 :
                        _c.name),
                    react.createElement("h6", null, (_d = bookingInfo === null || bookingInfo === void 0 ? void 0 : bookingInfo.specialistProfile) === null || _d === void 0 ? void 0 : _d.specialty),
                    react.createElement(ReviewsInfo, null,
                        react.createElement(RatingWrapper, null,
                            react.createElement(Star, null), (_f = (_e = bookingInfo === null || bookingInfo === void 0 ? void 0 : bookingInfo.specialistProfile) === null || _e === void 0 ? void 0 : _e.rating) !== null && _f !== void 0 ? _f : 0,
                            " Trust Score"),
                        react.createElement("span", null, "\u2022"),
                        react.createElement("span", null, (_g = bookingInfo === null || bookingInfo === void 0 ? void 0 : bookingInfo.specialistProfile) === null || _g === void 0 ? void 0 :
                            _g.reviewsNumber,
                            " reviews")))),
            react.createElement("hr", null),
            react.createElement("span", null, "Your booking request"),
            react.createElement(styles_esm_BookingInfo, { style: { marginTop: '8px' } },
                react.createElement("span", null, (_h = bookingInfo === null || bookingInfo === void 0 ? void 0 : bookingInfo.practiceProfile) === null || _h === void 0 ? void 0 : _h.name),
                react.createElement("span", null, "\u2022"),
                react.createElement("span", { style: { whiteSpace: 'nowrap' } },
                    formatDateStringToDisplay(bookingInfo === null || bookingInfo === void 0 ? void 0 : bookingInfo.dateString),
                    ' ',
                    formatTimeStringToDisplay(bookingInfo === null || bookingInfo === void 0 ? void 0 : bookingInfo.timeString))))));
};



;// CONCATENATED MODULE: ../../../packages/hermes-booking-calendar/lib/screens/SuccessAppointment/styles.esm.js


const SuccessAppointment_styles_esm_Container = (0,styled_esm/* default */.ZP)('div')({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    padding: '24px',
});
const SuccessAppointment_styles_esm_ContentWrapper = (0,styled_esm/* default */.ZP)('div')({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '32px',
    textAlign: 'center',
});
const styles_esm_Title = (0,styled_esm/* default */.ZP)('h1')(({ theme }) => ({
    color: theme.palette.system.navy900,
    textAlign: 'center',
    fontFamily: `'Klarheit Kurrent', sans-serif`,
    fontSize: '30px',
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: '40px',
    letterSpacing: '-1px',
    margin: 0,
}));
const LocationSection = (0,styled_esm/* default */.ZP)('div')(({ theme }) => ({
    color: theme.palette.system.navy900,
    textAlign: 'center',
    fontFamily: `'Poppins', sans-serif`,
    fontSize: '18px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '26px',
    '&>b': {
        fontWeight: 600,
    },
}));
const SummarySection = (0,styled_esm/* default */.ZP)('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '8px',
    color: theme.palette.system.navy900,
    textAlign: 'center',
    fontFamily: `'Poppins', sans-serif`,
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '20px',
}));
const Link = (0,styled_esm/* default */.ZP)('a')(({ theme }) => ({
    color: theme.palette.primary.main,
    textAlign: 'center',
    fontFamily: `'Poppins', sans-serif`,
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '24px',
    textDecorationLine: 'underline',
}));



;// CONCATENATED MODULE: ../../../packages/hermes-booking-calendar/lib/icons/AirplaneWithTracer.esm.js


const AirplaneWithTracer = () => {
    return (react.createElement("svg", { width: "176", height: "134", viewBox: "0 0 176 134", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        react.createElement("path", { d: "M110.843 97.1949V97.1949C102.836 117.1 79.7753 126.22 60.3197 117.177L58.2272 116.204L47.653 112.393C39.0474 109.292 35.4692 98.9867 40.1207 91.1103V91.1103C45.3562 82.245 58.0515 81.4432 64.1434 89.7434V89.7434C69.5128 97.0592 66.8267 107.46 58.5862 111.261L38.9206 120.331C32.9141 123.102 26.1972 123.945 19.6922 122.745L1.99986 119.483", stroke: "url(#paint0_linear_12502_5491)", strokeWidth: "3", strokeLinecap: "round", strokeDasharray: "4 8" }),
        react.createElement("path", { d: "M113.761 86.5233L111.656 64.8313C111.591 64.1543 112.206 63.6107 112.869 63.7587L121.604 65.7068C121.719 65.7324 121.828 65.7779 121.927 65.8414L127.845 69.6425C128.342 69.9614 128.456 70.6387 128.091 71.1024L115.542 87.0452C114.985 87.7536 113.848 87.4205 113.761 86.5233Z", fill: "#00897D", stroke: "#1A3586", strokeWidth: "2", strokeLinecap: "round" }),
        react.createElement("path", { d: "M139.585 20.5286L87.202 57.4009C85.0606 58.9082 85.7508 62.262 88.3146 62.8068L116.981 68.8981C117.507 69.01 117.995 69.2621 118.391 69.628L139.994 89.5544C141.926 91.3366 145.037 89.9499 145.008 87.3193L144.301 22.9695C144.275 20.5485 141.556 19.1414 139.585 20.5286Z", fill: "#B4FFFB" }),
        react.createElement("path", { d: "M139.585 20.5286L87.202 57.4009C85.0606 58.9082 85.7508 62.262 88.3146 62.8068L116.981 68.8981C117.507 69.01 117.995 69.2621 118.391 69.628L139.994 89.5544C141.926 91.3366 145.037 89.9499 145.008 87.3193L144.301 22.9695C144.275 20.5485 141.556 19.1414 139.585 20.5286Z", fill: "url(#paint1_linear_12502_5491)", fillOpacity: "0.7" }),
        react.createElement("path", { d: "M139.585 20.5286L87.202 57.4009C85.0606 58.9082 85.7508 62.262 88.3146 62.8068L116.981 68.8981C117.507 69.01 117.995 69.2621 118.391 69.628L139.994 89.5544C141.926 91.3366 145.037 89.9499 145.008 87.3193L144.301 22.9695C144.275 20.5485 141.556 19.1414 139.585 20.5286Z", stroke: "#1A3586", strokeWidth: "3" }),
        react.createElement("path", { d: "M128.253 54.299L121.405 69.967C121.303 70.2012 121.041 70.3197 120.797 70.2415L110.788 67.0241C110.409 66.9024 110.316 66.4068 110.624 66.1566L126.711 53.113C127.523 52.4542 128.672 53.3381 128.253 54.299Z", fill: "#1A3586" }),
        react.createElement("defs", null,
            react.createElement("linearGradient", { id: "paint0_linear_12502_5491", x1: "2", y1: "103.015", x2: "110.843", y2: "103.015", gradientUnits: "userSpaceOnUse" },
                react.createElement("stop", { offset: "0.05", stopColor: "#75F6EC" }),
                react.createElement("stop", { offset: "0.53", stopColor: "#5681FF" }),
                react.createElement("stop", { offset: "1", stopColor: "#1A3586" })),
            react.createElement("linearGradient", { id: "paint1_linear_12502_5491", x1: "97.0188", y1: "31.093", x2: "160.723", y2: "63.6157", gradientUnits: "userSpaceOnUse" },
                react.createElement("stop", { stopColor: "#B4FFFB" }),
                react.createElement("stop", { offset: "0.9999", stopColor: "#00E5D0" }),
                react.createElement("stop", { offset: "1", stopColor: "#00E5D0" })))));
};



;// CONCATENATED MODULE: ../../../packages/hermes-booking-calendar/lib/icons/Bell.esm.js


const Bell = () => {
    return (react.createElement("svg", { width: "30", height: "31", viewBox: "0 0 30 31", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        react.createElement("g", { clipPath: "url(#clip0_12502_5501)" },
            react.createElement("path", { d: "M19.7603 10.0944C19.3484 8.55734 18.3429 7.24683 16.9648 6.45118C15.5866 5.65553 13.9489 5.43992 12.4118 5.85178C10.8748 6.26364 9.56425 7.26923 8.7686 8.64734C7.97295 10.0254 7.75734 11.6632 8.1692 13.2003C9.98093 19.9617 7.60079 22.67 7.60079 22.67L24.9875 18.0113C24.9875 18.0113 21.572 16.8559 19.7603 10.0944Z", stroke: "#11245A", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
            react.createElement("path", { d: "M19.0003 23.7568C18.9089 24.0951 18.7303 24.4034 18.4823 24.6509C18.2343 24.8984 17.9256 25.0764 17.5872 25.1671C17.2487 25.2578 16.8924 25.258 16.5539 25.1676C16.2153 25.0773 15.9065 24.8996 15.6582 24.6523", stroke: "#11245A", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })),
        react.createElement("defs", null,
            react.createElement("clipPath", { id: "clip0_12502_5501" },
                react.createElement("rect", { width: "24", height: "24", fill: "white", transform: "translate(0.302979 7.02588) rotate(-15)" })))));
};



;// CONCATENATED MODULE: ../../../packages/hermes-booking-calendar/lib/screens/SuccessAppointment/index.esm.js







const SuccessAppointment = ({ location, locationContactNumber, profilePageLink, }) => {
    return (react.createElement(SuccessAppointment_styles_esm_Container, null,
        react.createElement(SuccessAppointment_styles_esm_ContentWrapper, null,
            resolveThemeComponent({
                default: react.createElement(AirplaneWithTracer, null),
            }),
            react.createElement("div", null,
                react.createElement(styles_esm_Title, null, "Your appointment request has been sent"),
                react.createElement(LocationSection, { style: { padding: '16px 0' } },
                    react.createElement("b", null, location),
                    react.createElement("div", null, "will contact you when they confirm it.")),
                react.createElement(SummarySection, null,
                    react.createElement(Bell, null),
                    resolveThemeComponent({
                        default: react.createElement("div", null, "Estimated time: Within 48 hours"),
                        wpa: react.createElement("div", null, "Estimated time: 48 hours"),
                    }),
                    react.createElement("div", null,
                        location,
                        ": ",
                        locationContactNumber))),
            react.createElement(Link, { href: profilePageLink }, "Back to profile page"))));
};



;// CONCATENATED MODULE: ../../../packages/hermes-booking-calendar/lib/screens/SlotNotAvailable/styles.esm.js


const SlotNotAvailable_styles_esm_Container = (0,styled_esm/* default */.ZP)('div')({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    padding: '24px',
});
const SlotNotAvailable_styles_esm_ContentWrapper = (0,styled_esm/* default */.ZP)('div')({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '24px',
    textAlign: 'center',
});
const styles_esm_SummarySection = (0,styled_esm/* default */.ZP)('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '8px',
    color: theme.palette.system.navy900,
    textAlign: 'center',
    fontFamily: `'Poppins', sans-serif`,
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 300,
    lineHeight: '24px',
}));
const SlotNotAvailable_styles_esm_Title = (0,styled_esm/* default */.ZP)('h1')(({ theme }) => ({
    color: theme.palette.text.darkNavy,
    textAlign: 'center',
    fontFamily: `'Klarheit Kurrent', sans-serif`,
    fontSize: '24px',
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: '32px',
    letterSpacing: '-1px',
    margin: 0,
}));



;// CONCATENATED MODULE: ../../../packages/hermes-booking-calendar/lib/icons/CalendarStyled.esm.js


const CalendarStyled = () => {
    return (react.createElement("svg", { width: "76", height: "71", viewBox: "0 0 76 71", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        react.createElement("rect", { x: "2.9375", y: "6.93945", width: "70.125", height: "61.875", rx: "8", fill: "#B4FFFB" }),
        react.createElement("rect", { x: "2.9375", y: "6.93945", width: "70.125", height: "61.875", rx: "8", fill: "url(#paint0_linear_10322_35454)", fillOpacity: "0.7" }),
        react.createElement("rect", { x: "2.9375", y: "6.93945", width: "70.125", height: "61.875", rx: "8", stroke: "#1A3586", strokeWidth: "4" }),
        react.createElement("path", { d: "M2.9375 23.4399H73.0625", stroke: "#1A3586", strokeWidth: "4", strokeLinecap: "round" }),
        react.createElement("path", { d: "M23.5629 2.81445L23.5629 11.0645", stroke: "#1A3586", strokeWidth: "4", strokeLinecap: "round" }),
        react.createElement("path", { d: "M52.4382 2.81445L52.4382 11.0645", stroke: "#1A3586", strokeWidth: "4", strokeLinecap: "round" }),
        react.createElement("path", { d: "M35.6626 68.5401C65.5826 68.5401 73.0626 43.6068 73.0626 31.1401V60.5401C73.0626 64.9584 69.4809 68.5401 65.0626 68.5401H35.6626Z", fill: "#00897D", stroke: "#1A3586", strokeWidth: "4", strokeLinecap: "round" }),
        react.createElement("defs", null,
            react.createElement("linearGradient", { id: "paint0_linear_10322_35454", x1: "2.9375", y1: "37.877", x2: "73.0625", y2: "37.877", gradientUnits: "userSpaceOnUse" },
                react.createElement("stop", { stopColor: "#B4FFFB" }),
                react.createElement("stop", { offset: "0.9999", stopColor: "#00E5D0" }),
                react.createElement("stop", { offset: "1", stopColor: "#00E5D0" })))));
};



;// CONCATENATED MODULE: ../../../packages/hermes-booking-calendar/lib/screens/SlotNotAvailable/index.esm.js







const SlotNotAvailable = ({ onButtonClick }) => {
    return (react.createElement(SlotNotAvailable_styles_esm_Container, null,
        react.createElement(SlotNotAvailable_styles_esm_ContentWrapper, null,
            resolveThemeComponent({
                default: react.createElement(CalendarStyled, null),
            }),
            react.createElement(styles_esm_SummarySection, null,
                react.createElement(SlotNotAvailable_styles_esm_Title, null, "Sorry, this time slot is no longer available."),
                react.createElement("span", null, "Please select another time from the calendar.")),
            react.createElement("div", null,
                react.createElement(Button_esm/* default */.Z, { variant: "tertiary", onClick: onButtonClick },
                    react.createElement(Typography_esm/* default */.Z, { component: "span" }, "Find another time slot"))))));
};



;// CONCATENATED MODULE: ../../../packages/hermes-booking-calendar/lib/screens/CaptchaError/index.esm.js




const CaptchaError = ({ profilePageLink }) => {
    return (react.createElement(SuccessAppointment_styles_esm_Container, null,
        react.createElement(SuccessAppointment_styles_esm_ContentWrapper, null,
            react.createElement(SlotNotAvailable_styles_esm_Title, null, "Could not verify reCAPTCHA. Please try again."),
            react.createElement(Link, { href: profilePageLink }, "Back to profile page"))));
};



;// CONCATENATED MODULE: ../../../packages/hermes-booking-calendar/lib/BookingCalendar.esm.js











const AppContainer = (0,styled_esm/* default */.ZP)('div')({
    display: 'flex',
    position: 'relative',
    width: '100%',
    height: '100%',
    overflowY: 'auto',
    overflowX: 'hidden',
    boxSizing: 'border-box',
});
const defaultDropdownLabel = 'Select from drop down';
const visitTypeOptions = [
    { label: 'New patient', value: 'new' },
    { label: 'Return patient', value: 'return' },
];
const bookForOptions = [
    { label: defaultDropdownLabel, value: null },
    { label: 'I am booking for myself', value: 'self' },
    { label: 'I am booking for someone else', value: 'someone-else' },
];
const titleOptions = [
    { label: defaultDropdownLabel, value: null },
    { label: 'Miss', value: 'miss' },
    { label: 'Mrs', value: 'mrs' },
    { label: 'Mr', value: 'mr' },
    { label: 'Other', value: 'other' },
];
const genderOptions = [
    {
        label: defaultDropdownLabel,
        value: null,
        prefix: '',
    },
    {
        label: 'Female',
        value: 'F',
        prefix: 'Ms',
    },
    {
        label: 'Male',
        value: 'M',
        prefix: 'Mr',
    },
    {
        label: 'Other',
        value: 'O',
        prefix: 'Mx',
    },
];
const BookingCalendar = ({ containerStyle, currentScreen, slots, specialistProfile, practiceProfile, visitReasons, onProfileSelectionClick, onDateSelectionClick, onTimeSelectionClick, onSlotSelectionClick, onBookButtonClick, onContactRequestClick, onSlotNotAvailableBackClick, onCalendarExpandClick, onBackButtonClick, onInsuranceSelectClick, onShowMoreDatesClick, onShowMoreSlotsClick, onViewAllAvailabilityClick, selectedInsurance, selectedDateString, selectedTimeString, changeScreen, expandedView, displayMobileContactPanel, displayLocationDropdown, formFields, availabilityId, provider, source, hideTitle = false, insurances = [], insuranceSelectMethod = 'dropdown', }) => {
    const screenNavigation = (0,react.useMemo)(() => {
        var _a, _b, _c, _d, _e;
        return ({
            [SCREENS.CALENDAR_PREVIEW]: (react.createElement(PreviewCalendar, { practiceProfile: practiceProfile, specialistProfile: specialistProfile, timeSlots: slots || [], onLocationChange: onProfileSelectionClick, onDateSelect: (date) => {
                    onDateSelectionClick === null || onDateSelectionClick === void 0 ? void 0 : onDateSelectionClick(date);
                    changeScreen(SCREENS.SLOT_SELECTION);
                }, onSlotSelect: (slot) => {
                    onSlotSelectionClick === null || onSlotSelectionClick === void 0 ? void 0 : onSlotSelectionClick(slot);
                    onTimeSelectionClick === null || onTimeSelectionClick === void 0 ? void 0 : onTimeSelectionClick(slot === null || slot === void 0 ? void 0 : slot.time, 'profile');
                    onDateSelectionClick === null || onDateSelectionClick === void 0 ? void 0 : onDateSelectionClick(slot === null || slot === void 0 ? void 0 : slot.date);
                    changeScreen(SCREENS.BOOKING_FORM);
                }, onCalendarOpen: onShowMoreDatesClick, onSlotsOpen: onShowMoreSlotsClick, onContactClick: onContactRequestClick, onViewAllAvailabilityClick: onViewAllAvailabilityClick, displayMobileContactPanel: displayMobileContactPanel, displayLocationDropdown: displayLocationDropdown, hideTitle: hideTitle })),
            [SCREENS.DATE_SELECTION]: (react.createElement(DateSelection, { onBackButtonClick: onBackButtonClick, selectableDates: (slots === null || slots === void 0 ? void 0 : slots.map((slot) => slot.date)) || [], onLocationChange: onProfileSelectionClick, onDateSelect: onDateSelectionClick, onCalendarExpandClick: onCalendarExpandClick, onNextStep: () => changeScreen(SCREENS.SLOT_SELECTION), expandedView: expandedView, bookingInfo: {
                    specialistProfile: specialistProfile,
                    practiceProfile: practiceProfile,
                    dateString: selectedDateString,
                    timeString: selectedTimeString,
                }, displayLocationDropdown: displayLocationDropdown })),
            [SCREENS.SLOT_SELECTION]: (react.createElement(index_esm_SlotSelection, { onBackButtonClick: onBackButtonClick, timeSlots: slots || [], onLocationChange: onProfileSelectionClick, onSlotSelect: (slot) => {
                    onSlotSelectionClick === null || onSlotSelectionClick === void 0 ? void 0 : onSlotSelectionClick(slot);
                    onTimeSelectionClick === null || onTimeSelectionClick === void 0 ? void 0 : onTimeSelectionClick(slot === null || slot === void 0 ? void 0 : slot.time);
                    onDateSelectionClick === null || onDateSelectionClick === void 0 ? void 0 : onDateSelectionClick(slot === null || slot === void 0 ? void 0 : slot.date);
                }, onNextStep: () => changeScreen(SCREENS.BOOKING_FORM), bookingInfo: {
                    specialistProfile: specialistProfile,
                    practiceProfile: practiceProfile,
                    dateString: selectedDateString,
                    timeString: selectedTimeString,
                }, displayLocationDropdown: displayLocationDropdown })),
            [SCREENS.BOOKING_FORM]: (react.createElement(BookingForm, { onBackButtonClick: onBackButtonClick, onFormSubmit: onBookButtonClick, onInsuranceSelectClick: onInsuranceSelectClick, visitTypeOptions: visitTypeOptions, visitReasonOptions: (_a = visitReasons === null || visitReasons === void 0 ? void 0 : visitReasons.map((item) => ({
                    label: item.name,
                    value: item.name,
                }))) !== null && _a !== void 0 ? _a : [], bookForOptions: bookForOptions, genderOptions: genderOptions, titleOptions: titleOptions, bookingInfo: {
                    specialistProfile: specialistProfile,
                    practiceProfile: practiceProfile,
                    dateString: selectedDateString,
                    timeString: selectedTimeString,
                    availabilityId,
                    provider,
                }, selectedInsurance: selectedInsurance, formFields: formFields, source: source, insuranceOptions: [
                    { label: 'Select', value: null },
                    ...((_b = insurances === null || insurances === void 0 ? void 0 : insurances.map((insurance) => ({
                        label: insurance.name,
                        value: String(insurance.id),
                    }))) !== null && _b !== void 0 ? _b : []),
                ], insuranceSelectMethod: insuranceSelectMethod })),
            [SCREENS.SUCCESS_APPOINTMENT]: (react.createElement(SuccessAppointment, { location: (_c = practiceProfile === null || practiceProfile === void 0 ? void 0 : practiceProfile.name) !== null && _c !== void 0 ? _c : '', locationContactNumber: practiceProfile === null || practiceProfile === void 0 ? void 0 : practiceProfile.contactNumber, profilePageLink: (_d = specialistProfile === null || specialistProfile === void 0 ? void 0 : specialistProfile.pageLink) !== null && _d !== void 0 ? _d : '' })),
            [SCREENS.SLOT_NOT_AVAILABLE]: (react.createElement(SlotNotAvailable, { onButtonClick: onSlotNotAvailableBackClick })),
            [SCREENS.CAPTCHA_ERROR]: (react.createElement(CaptchaError, { profilePageLink: (_e = specialistProfile === null || specialistProfile === void 0 ? void 0 : specialistProfile.pageLink) !== null && _e !== void 0 ? _e : '' })),
        });
    }, [
        practiceProfile,
        specialistProfile,
        slots,
        onProfileSelectionClick,
        onShowMoreDatesClick,
        onShowMoreSlotsClick,
        onContactRequestClick,
        onViewAllAvailabilityClick,
        displayMobileContactPanel,
        displayLocationDropdown,
        hideTitle,
        onBackButtonClick,
        onDateSelectionClick,
        onCalendarExpandClick,
        expandedView,
        selectedDateString,
        selectedTimeString,
        onBookButtonClick,
        onInsuranceSelectClick,
        visitReasons,
        availabilityId,
        provider,
        selectedInsurance,
        formFields,
        source,
        insurances,
        insuranceSelectMethod,
        onSlotNotAvailableBackClick,
        changeScreen,
        onSlotSelectionClick,
        onTimeSelectionClick,
    ]);
    return (react.createElement(AppContainer, { style: containerStyle }, screenNavigation[currentScreen]));
};



// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/styles/ThemeProvider.esm.js + 5 modules
var ThemeProvider_esm = __webpack_require__(97479);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/theme/index.esm.js + 26 modules
var theme_index_esm = __webpack_require__(1189);
;// CONCATENATED MODULE: ../../../packages/hermes-booking-calendar/lib/theme/wpa/palette.esm.js
const getPalette = (theme) => (Object.assign(Object.assign({}, theme.palette), { common: Object.assign(Object.assign({}, theme.palette.common), { bgColor: '#fff', border: '#2258B1', color: '#2C3341', lightNavy100: '#2258B1' }), primary: Object.assign(Object.assign({}, theme.palette.primary), { main: '#2258B1' }), system: Object.assign(Object.assign({}, theme.palette.system), { coral900: '#CC4F4A' }), blue: Object.assign(Object.assign({}, theme.palette.blue), { 200: '#E2EEFA' }), background: Object.assign(Object.assign({}, theme.palette.background), { default: '#F4F5F5', light: '#F0F4FF', light2: '#DCE4FF', light3: '#F3F7FD' }), error: Object.assign(Object.assign({}, theme.palette.error), { main: '#CC211A', light: '#FFEFEF' }) }));



;// CONCATENATED MODULE: ../../../packages/hermes-booking-calendar/lib/theme/wpa/components/Button.esm.js
function Button(theme) {
    return {
        defaultProps: {
            disableRipple: true,
        },
        styleOverrides: {
            root: {
                display: 'flex',
                gap: '10px',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '8px 24px',
                borderRadius: '20px',
                cursor: 'pointer',
                outline: 'inherit',
                border: 'none',
                fontFamily: `'Poppins', sans-serif`,
                fontSize: '14px',
                fontWeight: 500,
                lineHeight: '20px',
                textAlign: 'left',
                width: '100%',
                userSelect: 'none',
                transition: '0s !important',
                textTransform: 'none',
                '& > svg': {
                    minWidth: '20px',
                    minHeight: '20px',
                },
                '&:hover': {
                    opacity: '1 !important',
                },
                '&:disabled': {
                    backgroundColor: theme.palette.background.light3,
                    color: theme.palette.text.black600,
                    pointerEvents: 'none',
                    '& > svg': {
                        color: theme.palette.text.black600,
                    },
                },
            },
        },
        variants: [
            {
                props: { variant: 'primary1' },
                style: {
                    color: theme.palette.common.white,
                    backgroundColor: theme.palette.primary.main,
                    '&:hover, &:active': {
                        background: 'linear-gradient(90deg, rgba(43, 89, 224, 0.7) 50%, rgba(14, 182, 213, 0.513705) 83.26%, rgba(0, 229, 208, 0.7) 99.99%)',
                    },
                    '& > svg': {
                        color: theme.palette.common.white,
                    },
                },
            },
            {
                props: { variant: 'primary2' },
                style: {
                    padding: '8px 16px 8px 12px',
                    color: theme.palette.common.white,
                    backgroundColor: theme.palette.common.lightNavy100,
                    gap: '5px',
                    '&:hover, &:active': {
                        background: 'linear-gradient(90deg, rgba(17, 41, 113, 0.5) 0%, rgba(43, 89, 224, 0.5) 99.99%, rgba(43, 89, 224, 0.5) 100%), linear-gradient(0deg, #2B59E0, #2B59E0)',
                    },
                    '& > svg': {
                        color: theme.palette.common.white,
                    },
                },
            },
            {
                props: { variant: 'tertiary' },
                style: {
                    color: theme.palette.primary.main,
                    backgroundColor: theme.palette.common.white,
                    border: `1px solid ${theme.palette.primary.main}`,
                    '&:hover': {
                        backgroundColor: theme.palette.secondary.light,
                    },
                    '&:active': {
                        color: theme.palette.common.white,
                        backgroundColor: theme.palette.primary.main,
                    },
                },
            },
            {
                props: { variant: 'secondary' },
                style: {
                    padding: '8px',
                    border: `solid thin ${theme.palette.text.darkNavy900}`,
                    color: theme.palette.text.darkNavy900,
                    backgroundColor: 'transparent',
                    '& > svg': {
                        display: 'block',
                    },
                    '& > span': {
                        display: 'none',
                    },
                    '&:active': {
                        color: theme.palette.common.white,
                        backgroundColor: theme.palette.text.darkNavy900,
                    },
                    '@media (min-width: 480px)': {
                        padding: '8px 24px',
                        '&:hover': {
                            backgroundColor: theme.palette.background.default,
                        },
                        '& > svg': {
                            display: 'none',
                        },
                        '& > span': {
                            display: 'block',
                        },
                        '&:active': {
                            color: theme.palette.common.white,
                            backgroundColor: theme.palette.text.darkNavy900,
                        },
                    },
                },
            },
            {
                props: { variant: 'request' },
                style: {
                    color: theme.palette.common.white,
                    backgroundColor: theme.palette.primary.main,
                    '&:hover': {
                        background: 'linear-gradient(90deg, #2258B1 0%, #143977 100%)',
                    },
                },
            },
        ],
    };
}



;// CONCATENATED MODULE: ../../../packages/hermes-booking-calendar/lib/theme/wpa/overrides.esm.js


const getOverrides = (theme) => ({
    MuiButton: Button(theme),
});



;// CONCATENATED MODULE: ../../../packages/hermes-booking-calendar/lib/theme/wpa/index.esm.js




const palette = getPalette(theme_index_esm/* theme */.rS);
const wpaTheme = Object.assign(Object.assign({}, theme_index_esm/* theme */.rS), { name: 'wpa', palette });
wpaTheme.components = getOverrides(wpaTheme);



// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/styles/createTheme.esm.js + 13 modules
var createTheme_esm = __webpack_require__(27221);
;// CONCATENATED MODULE: ../../../packages/hermes-booking-calendar/lib/theme/default/palette.esm.js
const palette_esm_getPalette = (theme) => (Object.assign(Object.assign({}, theme.palette), { common: Object.assign(Object.assign({}, theme.palette.common), { bgColor: '#2B59E0', border: '#2B59E0', color: '#fff', lightNavy100: '#2258B1' }), primary: Object.assign(Object.assign({}, theme.palette.primary), { main: '#2258B1' }), system: Object.assign(Object.assign({}, theme.palette.system), { coral900: '#CC4F4A' }), background: Object.assign(Object.assign({}, theme.palette.background), { light: '#F0F4FF', light2: '#DCE4FF', light3: '#F3F7FD' }), error: Object.assign(Object.assign({}, theme.palette.error), { main: '#CC211A', light: '#FFEFEF' }) }));



;// CONCATENATED MODULE: ../../../packages/hermes-booking-calendar/lib/theme/default/components/Button.esm.js
function Button_esm_Button(theme) {
    return {
        defaultProps: {
            disableRipple: true,
        },
        styleOverrides: {
            root: {
                display: 'flex',
                gap: '10px',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '8px 24px',
                borderRadius: '20px',
                cursor: 'pointer',
                outline: 'inherit',
                border: 'none',
                fontFamily: `'Poppins', sans-serif`,
                fontSize: '14px',
                fontWeight: 500,
                lineHeight: '20px',
                textAlign: 'left',
                width: '100%',
                userSelect: 'none',
                transition: '0s !important',
                textTransform: 'none',
                '& > svg': {
                    minWidth: '20px',
                    minHeight: '20px',
                },
                '&:hover': {
                    opacity: '1 !important',
                },
                '& > span': {
                    fontWeight: 500,
                },
                '&:disabled': {
                    backgroundColor: theme.palette.background.light3,
                    color: theme.palette.text.black600,
                    pointerEvents: 'none',
                    '& > svg': {
                        color: theme.palette.text.black600,
                    },
                },
            },
        },
        variants: [
            {
                props: { variant: 'primary1' },
                style: {
                    color: theme.palette.common.white,
                    backgroundColor: theme.palette.primary.main,
                    '&:hover, &:active': {
                        background: 'linear-gradient(90deg, rgba(43, 89, 224, 0.7) 50%, rgba(14, 182, 213, 0.513705) 83.26%, rgba(0, 229, 208, 0.7) 99.99%)',
                    },
                    '& > svg': {
                        color: theme.palette.common.white,
                    },
                },
            },
            {
                props: { variant: 'primary2' },
                style: {
                    padding: '8px 16px 8px 12px',
                    color: theme.palette.common.white,
                    backgroundColor: theme.palette.primary.main,
                    gap: '5px',
                    '&:hover, &:active': {
                        background: 'linear-gradient(90deg, rgba(17, 41, 113, 0.5) 0%, rgba(43, 89, 224, 0.5) 99.99%, rgba(43, 89, 224, 0.5) 100%), linear-gradient(0deg, #2B59E0, #2B59E0)',
                    },
                    '& > svg': {
                        color: theme.palette.common.white,
                    },
                },
            },
            {
                props: { variant: 'tertiary' },
                style: {
                    color: theme.palette.primary.main,
                    backgroundColor: theme.palette.common.white,
                    border: `1px solid ${theme.palette.primary.main}`,
                    '&:hover': {
                        backgroundColor: theme.palette.secondary.light,
                    },
                    '&:active': {
                        color: theme.palette.common.white,
                        backgroundColor: theme.palette.primary.main,
                    },
                },
            },
            {
                props: { variant: 'secondary' },
                style: {
                    padding: '8px',
                    border: `solid thin ${theme.palette.text.darkNavy900}`,
                    color: theme.palette.text.darkNavy900,
                    backgroundColor: 'transparent',
                    '& > svg': {
                        display: 'block',
                    },
                    '& > span': {
                        display: 'none',
                    },
                    '&:active': {
                        color: theme.palette.common.white,
                        backgroundColor: theme.palette.text.darkNavy900,
                    },
                    '@media (min-width: 480px)': {
                        padding: '8px 24px',
                        '&:hover': {
                            backgroundColor: theme.palette.background.default,
                        },
                        '& > svg': {
                            display: 'none',
                        },
                        '& > span': {
                            display: 'block',
                        },
                        '&:active': {
                            color: theme.palette.common.white,
                            backgroundColor: theme.palette.text.darkNavy900,
                        },
                    },
                },
            },
            {
                props: { variant: 'request' },
                style: {
                    color: theme.palette.common.white,
                    backgroundColor: theme.palette.primary.main,
                    '&:hover, &:active': {
                        background: 'linear-gradient(90deg, rgba(43, 89, 224, 0.7) 50%, rgba(14, 182, 213, 0.513705) 83.26%, rgba(0, 229, 208, 0.7) 99.99%)',
                    },
                    '& > svg': {
                        color: theme.palette.common.white,
                    },
                },
            },
        ],
    };
}



;// CONCATENATED MODULE: ../../../packages/hermes-booking-calendar/lib/theme/default/overrides.esm.js


const overrides_esm_getOverrides = (theme) => ({
    MuiButton: Button_esm_Button(theme),
});



;// CONCATENATED MODULE: ../../../packages/hermes-booking-calendar/lib/theme/default/index.esm.js




const index_esm_palette = palette_esm_getPalette(theme_index_esm/* theme */.rS);
const defaultTheme = Object.assign(Object.assign({}, theme_index_esm/* theme */.rS), { name: 'default', palette: index_esm_palette });
defaultTheme.components = overrides_esm_getOverrides(defaultTheme);



;// CONCATENATED MODULE: ../../../packages/hermes-booking-calendar/lib/theme/index.esm.js




const themes = {
    default: defaultTheme,
    wpa: wpaTheme,
};
const getTheme = (themeName = 'default') => {
    return (0,createTheme_esm/* default */.Z)(Object.assign(Object.assign({}, themes[themeName]), { resolveThemeStyles: (styles) => styles[themeName] || {} }));
};



;// CONCATENATED MODULE: ../../../packages/hermes-booking-calendar/lib/index.esm.js









const defaultScreen = SCREENS.CALENDAR_PREVIEW;
const App = ({ currentScreen, slots, specialistProfile, practiceProfile, visitReasons, onProfileSelectionClick, onDateSelectionClick, onTimeSelectionClick, onSlotSelectionClick, onBookButtonClick = () => __awaiter(void 0, void 0, void 0, function* () { return true; }), onContactRequestClick, onSlotNotAvailableBackClick, onCalendarExpandClick, onChangeScreen, onBackButtonClick, onInsuranceSelectClick, onShowMoreDatesClick, onShowMoreSlotsClick, onViewAllAvailabilityClick, selectedInsurance, selectedDateString, selectedTimeString, containerStyle, expandedView, displayMobileContactPanel, displayLocationDropdown, formFields, availabilityId, provider, source, theme = 'default', hideTitle = false, insurances = [], insuranceSelectMethod = 'dropdown', }) => {
    const currentTheme = getTheme(theme);
    const [state, setState] = (0,react.useState)({
        practice: practiceProfile,
        specialist: specialistProfile,
        currentScreen: currentScreen !== null && currentScreen !== void 0 ? currentScreen : defaultScreen,
        selectedSlot: null,
        selectedDateString: undefined,
        selectedTimeString: undefined,
    });
    const changeScreen = (0,react.useCallback)((screen) => {
        setState((prev) => (Object.assign(Object.assign({}, prev), { currentScreen: screen })));
        onChangeScreen === null || onChangeScreen === void 0 ? void 0 : onChangeScreen(screen);
    }, [onChangeScreen]);
    const handleDateSelectionClick = (0,react.useCallback)((dateString) => {
        setState((prev) => (Object.assign(Object.assign({}, prev), { selectedDateString: dateString })));
        onDateSelectionClick === null || onDateSelectionClick === void 0 ? void 0 : onDateSelectionClick(dateString);
    }, [onDateSelectionClick]);
    const handleTimeSelectionClick = (0,react.useCallback)((timeString, triggerSource) => {
        setState((prev) => (Object.assign(Object.assign({}, prev), { selectedTimeString: timeString })));
        onTimeSelectionClick === null || onTimeSelectionClick === void 0 ? void 0 : onTimeSelectionClick(timeString, triggerSource);
    }, [onTimeSelectionClick]);
    const handleSlotSelectionClick = (0,react.useCallback)((slot) => {
        setState((prev) => (Object.assign(Object.assign({}, prev), { selectedSlot: slot !== null && slot !== void 0 ? slot : null })));
        onSlotSelectionClick === null || onSlotSelectionClick === void 0 ? void 0 : onSlotSelectionClick(slot);
    }, [onSlotSelectionClick]);
    const handleBookButtonClick = (0,react.useCallback)((formData) => onBookButtonClick(formData), [onBookButtonClick]);
    (0,react.useEffect)(() => {
        setState((prev) => (Object.assign(Object.assign({}, prev), { currentScreen: currentScreen !== null && currentScreen !== void 0 ? currentScreen : prev.currentScreen, practice: practiceProfile !== null && practiceProfile !== void 0 ? practiceProfile : prev.practice, specialist: specialistProfile !== null && specialistProfile !== void 0 ? specialistProfile : prev.specialist, selectedDateString: selectedDateString !== null && selectedDateString !== void 0 ? selectedDateString : prev.selectedDateString, selectedTimeString: selectedTimeString !== null && selectedTimeString !== void 0 ? selectedTimeString : prev.selectedTimeString })));
    }, [
        currentScreen,
        practiceProfile,
        specialistProfile,
        selectedDateString,
        selectedTimeString,
    ]);
    return (react.createElement(ThemeProvider_esm/* default */.Z, { theme: currentTheme },
        react.createElement(BookingCalendar, { containerStyle: containerStyle, currentScreen: state.currentScreen, changeScreen: changeScreen, slots: slots, specialistProfile: state.specialist, practiceProfile: state.practice, visitReasons: visitReasons, expandedView: expandedView, onProfileSelectionClick: onProfileSelectionClick, onDateSelectionClick: handleDateSelectionClick, onTimeSelectionClick: handleTimeSelectionClick, onSlotSelectionClick: handleSlotSelectionClick, onBookButtonClick: handleBookButtonClick, onContactRequestClick: onContactRequestClick, onSlotNotAvailableBackClick: onSlotNotAvailableBackClick, onInsuranceSelectClick: onInsuranceSelectClick, selectedInsurance: selectedInsurance, selectedDateString: state.selectedDateString, selectedTimeString: state.selectedTimeString, onCalendarExpandClick: onCalendarExpandClick, onBackButtonClick: onBackButtonClick, displayMobileContactPanel: displayMobileContactPanel, displayLocationDropdown: displayLocationDropdown, onShowMoreDatesClick: onShowMoreDatesClick, onShowMoreSlotsClick: onShowMoreSlotsClick, onViewAllAvailabilityClick: onViewAllAvailabilityClick, formFields: formFields, availabilityId: availabilityId, provider: provider, source: source, hideTitle: hideTitle, insurances: insurances, insuranceSelectMethod: insuranceSelectMethod })));
};
const index_esm_SCREENS = SCREENS;
const calendarUtils = {
    formatTimeStringToDisplay: formatTimeStringToDisplay,
    formatDateStringToDisplay: formatDateStringToDisplay,
};




/***/ })

}]);